import axios from "axios";
import React from "react";
import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import { useEffect, useRef } from "react";
import { IconButton, Menu, MenuItem, TableBody, TableHead } from "@mui/material";
import { Card, Col, Container, Row, Table } from "react-bootstrap";
import { ChangeCursor } from "./MiscFunctions";
import { Modal, Button } from "react-bootstrap";
import { DevTool } from "@hookform/devtools";
import "./RegisterPatient.scss";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Link } from "@mui/material";
import { toast } from "react-toastify";
import { displayPatientName } from "../../../utils/displayPatientName";
import DisplayDate from "../../../components/date/DisplayDate";
import SearchIcon from "@mui/icons-material/Search";
import ResendOtpTimer from "../../../components/Utils/ResendOtpTimer";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

import Tooltip from "@mui/material/Tooltip";

import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import CancelIcon from "@mui/icons-material/Cancel";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";

import {
  CardContent,
  Typography,
  Avatar,
  Grid,
  Radio,
  FormControl,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import GenerateAbha from "./GenerateAbha";
import VerifyAbha from "./VerifyAbha";
import { StyledButton } from "../../doctor-console/StyledComponents";
import ProfileCard from "./ProfileCard";
import { Icons } from "../../doctor-console/Utils/iconsRegistry";
import {
  FINANCIAL_CLASSES,
  SOURCE_TYPES,
} from "../../ipd/pages/patient-admission-ipd/constants/registrationConstants";
import {
  fetchPayersByFinanceClass,
  fetchReferralDoctors,
  addReferralDoctorToMaster,
} from "../../ipd/pages/patient-admission-ipd/api/registrationService";
import DemoEmergencyRegisterSection from "./DemoEmergencyRegisterSection";
import AddIcon from "@mui/icons-material/Add";
import ScanDocumentDialog from "../../ipd/pages/patient-admission-ipd/components/dialogs/ScanDocumentDialog";
import CrossDeviceQrDialog from "../../ipd/pages/patient-admission-ipd/components/dialogs/CrossDeviceQrDialog";
import PhotoQrDialog from "../../ipd/pages/patient-admission-ipd/components/dialogs/PhotoQrDialog";
import { parseDocumentDob } from "../../ipd/pages/patient-admission-ipd/utils/documentAutofill";

const REGISTRATION_TYPE_OPTIONS = [
  { value: "GENERAL", label: "General" },
  { value: "EMERGENCY", label: "Emergency" },
];
const DEMO_FINANCIAL_CLASSES = FINANCIAL_CLASSES.filter(
  ([value]) => value !== "TPA" && value !== "STAFF"
);
const SOURCE_TYPE_VALUE_KEYS = {
  HOSPITAL: "hospitalName",
  MARKETING_PERSON: "marketingName",
  EMPLOYEE: "employeeName",
  EXTERNAL_DOCTOR: "referralDoctorId",
};

function mapDemoFinancePayer(financialClass, payer) {
  const trimmed = String(payer || "").trim();
  if (trimmed) return trimmed;
  if (financialClass === "CASH") return "self_pay";
  return "";
}

function buildDemoPatientSource(sourceType, sourceFields) {
  if (!sourceType) {
    return { source_type: "WALK_IN", source_type_value: "Direct" };
  }
  const valueKey = SOURCE_TYPE_VALUE_KEYS[sourceType];
  return {
    source_type: sourceType,
    source_type_value: valueKey ? sourceFields[valueKey] || "" : "",
  };
}

/** Age in years and months from YYYY-MM-DD (calendar-based). */
function computeAgeYearsMonthsFromDob(dateString) {
  if (!dateString) return null;
  const birthDate = new Date(dateString);
  if (Number.isNaN(birthDate.getTime())) return null;
  const today = new Date();
  if (birthDate > today) return { years: 0, months: 0 };
  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  if (today.getDate() < birthDate.getDate()) {
    months--;
  }
  if (months < 0) {
    years--;
    months += 12;
  }
  if (years < 0) return { years: 0, months: 0 };
  return { years, months };
}

/** Approximate DOB from age years/months (subtracts from today). */
function estimateDobFromAgeYearsMonths(yearsStr, monthsStr) {
  const y = yearsStr === "" ? 0 : parseInt(yearsStr, 10);
  const m = monthsStr === "" ? 0 : parseInt(monthsStr, 10);
  if (isNaN(y) || y < 0 || y > 150) return null;
  const mo = isNaN(m) ? 0 : Math.min(11, Math.max(0, m));
  const d = new Date();
  d.setHours(12, 0, 0, 0);
  d.setFullYear(d.getFullYear() - y);
  d.setMonth(d.getMonth() - mo);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function RegisterPatient() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
  } = useForm();
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    getValues: getValues1,
    watch: watch1,
    setValue: setValue1,
  } = useForm();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    getValues: getValues2,
    setValue: setValue2,
  } = useForm();
  const {
    register: register3,
    handleSubmit: handleSubmit3,
    formState: { errors: errors3 },
    getValues: getValues3,
    watch: watch3,
    setValue: setValue3,
  } = useForm();
  const {
    register: register4,
    handleSubmit: handleSubmit4,
    formState: { errors: errors4 },
    getValues: getValues4,
    setValue: setValue4,
  } = useForm();
  const {
    register: register5,
    handleSubmit: handleSubmit5,
    formState: { errors: errors5 },
    setError: setError5,
    getValues: getValues5,
    watch: watch5,
    setValue: setValue5,
  } = useForm();
  const {
    register: register6,
    handleSubmit: handleSubmit6,
    formState: { errors: errors6 },
    setError: setError6,
    getValues: getValues6,
    watch: watch6,
    setValue: setValue6,
  } = useForm();
  const {
    register: register7,
    handleSubmit: handleSubmit7,
    formState: { errors: errors7 },
    setError: setError7,
    getValues: getValues7,
    watch: watch7,
    setValue: setValue7,
  } = useForm();
  const {
    register: register8,
    handleSubmit: handleSubmit8,
    formState: { errors: errors8 },
    setError: setError8,
    getValues: getValues8,
    watch: watch8,
    setValue: setValue8,
  } = useForm();
  const {
    register: register9,
    handleSubmit: handleSubmit9,
    formState: { errors: errors9 },
    setError: setError9,
    getValues: getValues9,
    watch: watch9,
    setValue: setValue9,
    control,
    reset: reset9,
  } = useForm();
  const {
    register: register10,
    handleSubmit: handleSubmit10,
    formState: { errors: errors10 },
    setError: setError10,
    getValues: getValues10,
    watch: watch10,
    setValue: setValue10,
  } = useForm();
  const {
    register: register11,
    handleSubmit: handleSubmit11,
    formState: { errors: errors11 },
    setError: setError11,
    getValues: getValues11,
    watch: watch11,
    setValue: setValue11,
    reset: reset11,
  } = useForm();
  const {
    register: register12,
    handleSubmit: handleSubmit12,
    formState: { errors: errors12 },
    setError: setError12,
    getValues: getValues12,
    watch: watch12,
    setValue: setValue12,
  } = useForm();

  const {
    register: register13,
    handleSubmit: handleSubmit13,
    formState: { errors: errors13 },
    setError: setError13,
    getValues: getValues13,
    watch: watch13,
    setValue: setValue13,
  } = useForm();

  const {
    register: register14,
    handleSubmit: handleSubmit14,
    formState: { errors: errors14 },
    setError: setError14,
    getValues: getValues14,
    watch: watch14,
    setValue: setValue14,
  } = useForm();

  console.log("Env Abha Regex", process.env);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [userRole, setUserRole] = useState(sessionStorage.getItem("roleType"));
  const [displayOtpVerify, setDisplayOtpVerify] = useState(false);
  const [displayPatientDetails, setDisplayPatientDetails] = useState(false);
  const [displayVerfiyPhoneNum, setDisplayVerfiyPhoneNum] = useState(false);
  const [displayGeneratehealthId, setDisplayGeneratehealthId] = useState(false);
  const [displayHealthIdDetails, setDisplayHealthIdDetails] = useState(false);
  const [displayHealthIdDetails1, setDisplayHealthIdDetails1] = useState(false);
  const [healthIdDetails1, setHealthIdDetails1] = useState(false);
  const [displayDownloadOTP, setDisplayDownloadOTP] = useState(false);
  const [displayDownloadOTPDirect, setDisplayDownloadOTPDirect] =
    useState(false);
  const [displayDownloadOTPVerify, setDisplayDownloadOTPVerify] =
    useState(false);
  const [displayPreview, setDisplayPreview] = useState(false);
  const [previewData, setPreviewData] = useState(false);
  const [healthIdDetails, setHealthIdDetails] = useState(false);
  const [patientName, setPatientName] = useState("");
  const [txnId, setTxnId] = useState(false);
  const [txnIdDownload, setTxnIdDownload] = useState(false);
  const [dissableAllButtonsVerify, setDissableAllButtonsVerify] =
    useState(false);
  const [tokenForCardV3, setTokenForCardV3] = useState();
  const [isCardSelectionFrozen, setIsCardSelectionFrozen] = useState(false);
  const [suggestionABHA, setSuggestionABHA] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [buttonDisabledMobileOtp, setButtonDisabledMobileOtp] = useState(false);
  const [buttonDisabledVerify, setButtonDisabledVerify] = useState(false);
  const [buttonDisabledAbha, setButtonDisabledAbha] = useState(false);
  const [patientDetails, setPatientDetails] = useState([]);
  const [authModes, setAuthModes] = useState(["AADHAAR_OTP", "MOBILE_OTP"]);
  const [patientList, setPatientList] = useState([]);
  const RESEND_OTP_TIMER = process.env.REACT_APP_RESEND_OTP_TIMER;
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const REACT_APP_SUFFIX =
    process.env.REACT_APP_IS_ABDM_CONNECTED_WITH_PROD === "true"
      ? process.env.REACT_APP_SUFFIX_PR
      : process.env.REACT_APP_SUFFIX_SB;
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [showAbhaCreate, SetshowAbhaCreate] = useState(false);
  const [finalTransactionId, setFinalTransactionId] = useState(false);
  const [generateAbhaButton, setGenerateAbhaButton] = useState(false);
  const [verifyPhoneButton, setVerifyPhoneButton] = useState(false);
  const [finalAbhaIdCreateButton, setFinalAbhaIdCreateButton] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [otpResendCount, setOtpResendCount] = useState(0);
  const [otpResendCountGenerate, setOtpResendCountGenerate] = useState(0);
  const [otpResendCountGenerateMobile, setOtpResendCountGenerateMobile] =
    useState(0);
  const [showDownloadAbhaModal, setShowDownloadAbhaModal] = useState(false);
  const [PatientData, setPatientData] = useState();
  const [showFind, setShowFind] = useState(false);
  const [phrAddress, setPhrAddress] = useState([]);
  const [searchTypePatient, setSearchTypePatient] = useState("");
  const [navigateToAbha, setNavigateToAbha] = useState(false);
  const [executionTime, setExecutionTime] = useState(0);
  const [executionTimeMobile2, setExecutionTimeMobile2] = useState(0);
  const [insuranceSchemes, setInsuranceSchemes] = useState([]);
  const [patientIdForSearch, SetPatientIdForSearch] = useState();
  const [patientListWithAbhaAndId, setPatientListWithAbhaAndId] = useState([]);
  const [selectedSchemes, setSelectedSchemes] = useState([]);
  const [patients, setPatients] = useState([]);
  const [selectedPatId, setselectedPatId] = useState(null);
  const [disableForMobileVerify, setDisableForMobileVerify] = useState(false);
  const [patientForMobileSearch, setPatientForMobileSearch] = useState();
  const [continueWithMobileVerification, setContinueWithMobileVerification] =
    useState(false);
  const [
    continueWithMobileVerificationVisible,
    setContinueWithMobileVerificationVisible,
  ] = useState(false);
  const [otpResendCountVerifyForMobile, setOtpResendCountVerifyForMobile] =
    useState(0);
  const [buttonDisabledContinueForMobile, setButtonDisabledContinueForMobile] =
    useState(false);
  const [isContinueButtonClicked, setIsContinueButtonClicked] = useState(false);
  const [multiplePatientData, setMultiplePatientData] = useState([]);
  const [taggingPatientId, setTaggingPatientId] = useState();
  const [selectedPartiallyMatchedPatient, setSelectedPartiallyMatchedPatient] =
    useState();
  const [
    transactionIdForDataVerification,
    setTransactionIdForDataVerification,
  ] = useState("");
  const [multipleMatchedData, setMultipleMatchedData] = useState([]);
  const [activePatientId, setActivePatientId] = useState(null);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [selectedABHANumber, setSelectedABHANumber] = useState("");
  const [txnIdV3, setTxnIdV3] = useState("");
  const today = new Date().toISOString().split("T")[0];

  const [disableVerifyAndResendOtpButton, setDisableVerifyAndResendOtpButton] =
    useState(false);
  const [
    disableVerifyAndResendOtpMobileButton,
    setDisableVerifyAndResendOtpMobileButton,
  ] = useState(false);
  const [tokenForCard, setTokenForCard] = useState("");
  const abhaAddress = watch("health_id");
  const selectedAuthModeW = watch("selected_auth_mode");
  const [profilePhoto, setProfilePhoto] = useState(null);
  // True once the user picks or discards a photo; the circle's photo is then what gets saved.
  const [photoChanged, setPhotoChanged] = useState(false);
  const [photoMenuAnchor, setPhotoMenuAnchor] = useState(null);
  const [photoQrOpen, setPhotoQrOpen] = useState(false);
  const photoInputRef = useRef(null);
  const [uploadDocOpen, setUploadDocOpen] = useState(false);
  const [docQrOpen, setDocQrOpen] = useState(false);
  useEffect(() => {
    setDisplayDownloadOTPVerify(false);
    setButtonDisabledVerify(false);
    setOtpResendCount(0);
    setTokenForCard("");
    setDissableAllButtonsVerify(false);
    setSelectedABHANumber("");
    setTxnIdV3("");
    setAccounts([]);
    setIsCardSelectionFrozen(false);
    setTokenForCardV3("");
    setValue8("abha_id_otp", "");
    setNavigateToAbha(false);
  }, [abhaAddress, selectedAuthModeW]);

  const abhaAddressforDownload = watch6("abha_id");
  useEffect(() => {
    setOtpResendCount(0);
    setIsButtonClicked(false);
    setButtonDisabledAbha(false);
    setDisplayDownloadOTPDirect(false);
  }, [abhaAddressforDownload]);
  const [accounts, setAccounts] = useState([]);
  const [isAbdmEnabled, setIsAbdmEnabled] = useState(
    sessionStorage.getItem("isAbdmEnabled") !== undefined &&
      sessionStorage.getItem("isAbdmEnabled") !== null
      ? JSON.parse(sessionStorage.getItem("isAbdmEnabled"))
      : false
  );
  const [age, setAge] = useState("");
  const [ageMonths, setAgeMonths] = useState("");
  const [lastUpdatedField, setLastUpdatedField] = useState(null);

  const [facilityType, setFacilityType] = useState(null);
  const [registrationType, setRegistrationType] = useState("GENERAL");
  const [financialClass, setFinancialClass] = useState("");
  const [financePayer, setFinancePayer] = useState("");
  const [financePayers, setFinancePayers] = useState([]);
  const [loadingFinancePayers, setLoadingFinancePayers] = useState(false);
  const [patientSourceType, setPatientSourceType] = useState("");
  const [patientSourceFields, setPatientSourceFields] = useState({
    hospitalName: "",
    marketingName: "",
    employeeName: "",
    referralDoctorId: "",
  });
  const [referralDoctors, setReferralDoctors] = useState([]);
  const [loadingReferralDoctors, setLoadingReferralDoctors] = useState(false);
  const [addReferralDoctorOpen, setAddReferralDoctorOpen] = useState(false);
  const [newReferralDoctorName, setNewReferralDoctorName] = useState("");
  const [newReferralDoctorPhone, setNewReferralDoctorPhone] = useState("");
  const [addingReferralDoctor, setAddingReferralDoctor] = useState(false);
  const showRegistrationTypeDropdown =
    facilityType != null && facilityType !== "OPD";
  const isEmergencyRegistration = registrationType === "EMERGENCY";

  const watchedDateOfBirth = watch9("dateOfBirth");
  const watchedPincode = watch9("pincode");

  useEffect(() => {
    if (!authToken) return undefined;
    let cancelled = false;
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`, {
        headers,
      })
      .then((res) => {
        if (cancelled || res.data?.status !== "Success") return;
        const ft = res.data.facility_type || "OPD";
        console.log("facility type ft", ft);
        setFacilityType(ft);
        if (ft === "OPD") {
          setRegistrationType("GENERAL");
        }
      })
      .catch((err) => {
        console.error("Failed to load facility type:", err);
        if (!cancelled) setFacilityType("OPD");
      });
    return () => {
      cancelled = true;
    };
  }, [authToken]);

  console.log("facility type", facilityType);

  useEffect(() => {
    const normalizedClass = String(financialClass || "").trim();
    if (!normalizedClass) {
      setFinancePayers([]);
      setLoadingFinancePayers(false);
      return undefined;
    }
    let cancelled = false;
    setLoadingFinancePayers(true);
    fetchPayersByFinanceClass(normalizedClass)
      .then((list) => {
        if (!cancelled) setFinancePayers(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (!cancelled) setFinancePayers([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingFinancePayers(false);
      });
    return () => {
      cancelled = true;
    };
  }, [financialClass]);

  useEffect(() => {
    if (patientSourceType !== "EXTERNAL_DOCTOR") return undefined;
    let cancelled = false;
    setLoadingReferralDoctors(true);
    fetchReferralDoctors()
      .then((doctors) => {
        if (!cancelled) setReferralDoctors(Array.isArray(doctors) ? doctors : []);
      })
      .catch(() => {
        if (!cancelled) setReferralDoctors([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingReferralDoctors(false);
      });
    return () => {
      cancelled = true;
    };
  }, [patientSourceType]);

  const loadReferralDoctors = async () => {
    setLoadingReferralDoctors(true);
    try {
      const doctors = await fetchReferralDoctors();
      const list = Array.isArray(doctors) ? doctors : [];
      setReferralDoctors(list);
      return list;
    } catch (err) {
      toast.error(err?.message || "Failed to load referral doctors");
      setReferralDoctors([]);
      return [];
    } finally {
      setLoadingReferralDoctors(false);
    }
  };

  const handleAddReferralDoctor = async () => {
    if (
      !newReferralDoctorName.trim() ||
      !/^\d{7,}$/.test(newReferralDoctorPhone)
    ) {
      toast.error("Doctor name and valid phone are required");
      return;
    }
    setAddingReferralDoctor(true);
    try {
      const created = await addReferralDoctorToMaster({
        name: newReferralDoctorName,
        phoneNo: newReferralDoctorPhone,
      });
      const doctors = await loadReferralDoctors();
      const selectedId =
        created.id ||
        doctors.find((doctor) => doctor.phone === newReferralDoctorPhone)?.id ||
        "";
      if (selectedId) {
        setPatientSourceFields((f) => ({
          ...f,
          referralDoctorId: selectedId,
        }));
      }
      setNewReferralDoctorName("");
      setNewReferralDoctorPhone("");
      setAddReferralDoctorOpen(false);
      toast.success(created.message || "Referral doctor added to master");
    } catch (err) {
      toast.error(err?.message || "Failed to add referral doctor");
    } finally {
      setAddingReferralDoctor(false);
    }
  };

  useEffect(() => {
    if (lastUpdatedField === "dob" && watchedDateOfBirth) {
      const computed = computeAgeYearsMonthsFromDob(watchedDateOfBirth);
      if (computed) {
        setAge(String(computed.years));
        setAgeMonths(String(computed.months));
      }
    }
  }, [watchedDateOfBirth, lastUpdatedField]);

  useEffect(() => {
    if (lastUpdatedField === "age" && (age !== "" || ageMonths !== "")) {
      const estimatedDob = estimateDobFromAgeYearsMonths(age, ageMonths);
      if (estimatedDob) {
        setValue9("dateOfBirth", estimatedDob, {
          shouldValidate: true,
          shouldDirty: true,
        });
      }
    }
  }, [age, ageMonths, lastUpdatedField]);

  const handleVerifyButtonClick = () => {
    setShowVerifyModal(true);
    if (showFind) {
      setTaggingPatientId(PatientData.patient_id ? PatientData.patient_id : "");
    }
  };

  const handleGenerateButtonClick = () => {
    setShowGenerateModal(true);
    if (showFind) {
      setTaggingPatientId(PatientData.patient_id ? PatientData.patient_id : "");
    }
  };

  // const handleCloseVerifyModal = () => setShowVerifyModal(false);
  // const handleCloseVerifyModal = () => {
  //   setDisplayPatientDetails(false);
  //   setShowVerifyModal(false);
  // }

  const handleCloseVerifyModal = () => {
    setDisplayPatientDetails(false);
    setShowVerifyModal(false);

    setValue("health_id", "");

    // setValue("selected_auth_mode", "");
    setValue8("abha_id_otp", "");

    setDisplayHealthIdDetails(false);
    setDisplayDownloadOTPVerify(false);
    setTokenForCard("");
    setOtpResendCount(0);
    setSelectedABHANumber("");
    setTxnIdV3("");
    setAccounts([]);
    setDissableAllButtonsVerify(false);
    setIsCardSelectionFrozen(false);
    setTokenForCardV3("");
    setNavigateToAbha(false);
    // clearSearch();
    if (multipleMatchedData.length == 0) {
      fetchPatientDetails();
    }
    setMultiplePatientData([]);

    setPatients([]);
    setselectedPatId(null);
    setDisableForMobileVerify(false);
    setPatientForMobileSearch();
    setContinueWithMobileVerification(false);
    setContinueWithMobileVerificationVisible(false);
    setOtpResendCountVerifyForMobile(0);
    setButtonDisabledContinueForMobile(false);
    setIsContinueButtonClicked(false);
    setMultipleMatchedData([]);
  };

  console.log("tosee", multiplePatientData);
  const handleCloseDownloadModal = () => {
    setShowDownloadAbhaModal(false);
    setValue6("abha_id", "");
    setValue7("abha_id_otp", "");
    setDisplayDownloadOTPDirect(false);
    setPatientDetails([]);
    setDisplayPreview(false);
    setPreviewData("");
    setButtonDisabledAbha(false);
    setIsButtonClicked(false);
    setOtpResendCount(0);
    clearSearch();
    fetchPatientDetails();
  };
  const handleDownloadClick = () => {
    setShowDownloadAbhaModal(true);
    if (showFind) {
      handleDone();
    }
  };
  const handleFindClick = () => {
    setShowFind(true);
    SetPatientIdForSearch("");
    setHealthIdDetails(false);
    setSelectedSchemes([]);
    reset9();
  };

  const handleCloseGenerateModal = () => {
    setValue1("Aadhaar_number", "");
    setValue5("check_all", false);

    setValue5("consent_1", false);
    setValue5("consent_2", false);
    setValue5("consent_3", false);
    setValue5("consent_4", false);
    setValue5("consent_5", false);
    setValue5("consent_6", false);
    setValue5("consent_7", false);
    setDisplayOtpVerify(false);
    setDisplayPatientDetails(false);

    setDisplayOtpVerify(false);
    setDisplayPatientDetails(false);
    setDisplayVerfiyPhoneNum(false);
    setDisplayGeneratehealthId(false);

    setValue2("otp", "");
    setValue3("other_number", "");
    setValue4("mobileOTP", "");
    setValue5("patient_email", "");
    setValue5("health_id", "");

    setShowGenerateModal(false);
    setDisableVerifyAndResendOtpButton(false);
    setButtonDisabledMobileOtp(false);
    setButtonDisabled(false);
    SetshowAbhaCreate(false);
    setTokenForCard("");
    setOtpResendCountGenerate(0);
    setOtpResendCountGenerateMobile(0);
    clearSearch();
  };
  const [displayDownloadOTPReVerify, setDisplayDownloadOTPReVerify] =
    useState(false);
  // const [data, setData] = useState([]);
  const [country, setCountry] = useState(["India"]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const healthId = watch("health_id");

  // useEffect(() => {
  //   if (healthId && /^\d+$/.test(healthId)) {
  //     if (healthId.length === 10) {
  //       setAuthModes(["MOBILE_OTP"]);
  //     } else if (healthId.length === 12) {
  //       setAuthModes(["AADHAAR_OTP"]);
  //     } else {
  //       setAuthModes(["AADHAAR_OTP", "MOBILE_OTP"]);
  //     }
  //   } else {
  //     setAuthModes(["AADHAAR_OTP", "MOBILE_OTP"]);
  //   }
  // }, [healthId]);
  useEffect(() => {
    if (healthId) {
      if (healthId.endsWith(REACT_APP_SUFFIX)) {
        // If healthId ends with the required suffix, make API call
        fetchAuthMethodsForAbha(healthId);
      } else if (/^\d+$/.test(healthId)) {
        // If healthId is numeric, determine authModes based on length
        if (healthId.length === 10) {
          setAuthModes(["MOBILE_OTP"]);
        } else if (healthId.length === 12) {
          setAuthModes(["AADHAAR_OTP"]);
        } else {
          setAuthModes(["AADHAAR_OTP", "MOBILE_OTP"]);
        }
      } else {
        // Default case for non-matching inputs
        setAuthModes(["AADHAAR_OTP", "MOBILE_OTP"]);
      }
    }
  }, [healthId]);

  useEffect(() => {
    if (authModes.length > 0) {
      setValue("selected_auth_mode", authModes[0]);
    }
  }, [authModes]);

  useEffect(() => {
    if (healthIdDetails) {
      let abhaNo = "";
      if (healthIdDetails.healthIdNumber) {
        abhaNo = healthIdDetails.healthIdNumber;
      } else if (healthIdDetails.ABHANumber) {
        abhaNo = healthIdDetails.ABHANumber;
      } else if (healthIdDetails.abhaNumber) {
        abhaNo = healthIdDetails.abhaNumber;
      }

      if (abhaNo) {
        const filterCriteria = {
          filter_type: "abha_number",
          filter_details: {
            abha_number: abhaNo,
          },
        };
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_patient_data/`,
            filterCriteria,
            { headers: headers }
          )
          .then((response) => {
            console.log(response.data);
            if (response.data.status === "Success") {
              SetPatientIdForSearch(response.data.patient_details.patient_id);
            } else if (response.data.status === "Failed") {
              console.log("patient not found in the search");
            } else {
              toast.error("Error");
            }
          })
          .catch((error) => {
            console.log("FETCH FAILED");
            console.log(error);
          });
      }
    }
  }, [healthIdDetails]);
  console.log("patientidto check", patientIdForSearch);

  useEffect(() => {
    console.log("init");

    console.log(authToken);

    if (authToken !== "") {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_states/`, {
          headers: headers,
        })
        .then((res) => {
          setStates(res.data.state_list);
          console.log(res.data.state_list);
        });
    }
  }, [authToken]);

  const getStates = (stateName) => {
    console.log("stateName", stateName);
    var post_data = {
      state_name: stateName,
    };

    if (authToken !== "") {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_districts/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log(res.data);
          setCities(res.data.district_list);
        });
    }
  };

  const fetchPincodeDetails = (pincode) => {
    if (!pincode || !/^\d{6}$/.test(pincode)) return;

    axios
      .get(
        `${REACT_APP_BACKEND_ROUTE_URL}get_pincode_details/?pincode=${pincode}`
      )
      .then((res) => {
        if (
          res.data.status === "Success" &&
          res.data.pincode_details?.length > 0
        ) {
          const details = res.data.pincode_details[0];
          const stateName = details.statename;
          const districtName = details.district;

          const matchedState = states.find(
            (s) => s.state_name.toLowerCase() === stateName.toLowerCase()
          );

          const stateValue = matchedState
            ? matchedState.state_name.toLowerCase()
            : stateName.toLowerCase();
          const stateForDistricts = matchedState
            ? matchedState.state_name
            : stateName;

          setValue9("state", stateValue);
          setSelectedState(stateValue);
          getStates(stateForDistricts);

          setValue9("district", districtName.toLowerCase());
          setSelectedDistrict(districtName.toLowerCase());
        }
      })
      .catch((err) => {
        console.error("Error fetching pincode details:", err);
      });
  };

  useEffect(() => {
    if (watchedPincode && /^\d{6}$/.test(watchedPincode)) {
      fetchPincodeDetails(watchedPincode);
    }
  }, [watchedPincode]);

  const updateHealthIdDetails = (newDetails) => {
    setHealthIdDetails(newDetails);
  };

  // const getAllInsuranceScheme = () => {

  //   if (authToken !== "") {
  //     axios
  //       .get(
  //         `${REACT_APP_BACKEND_ROUTE_URL}get_all_insurance_schemes/`,
  //         {
  //           headers: headers,
  //         }
  //       )
  //       .then((res) => {
  //         console.log(res.data);
  //         if(res.data.status ==="Success"){
  //           setInsuranceSchemes(res.data.subscription_types);
  //         }else{
  //             console.log("error in getting subscription_types")
  //         }

  //       });
  //   }
  // };

  const getAllInsuranceScheme = () => {
    if (authToken !== "") {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_insurance_schemes/`, {
          headers: headers,
        })
        .then((res) => {
          console.log("API Response:", res.data);
          // Checking if res.data is an array and each item has a name property
          if (
            Array.isArray(res.data?.data) &&
            res.data?.data.every((item) => typeof item.name === "string")
          ) {
            const formattedSchemes = res.data?.data.map(
              (scheme) => scheme.name
            );
            setInsuranceSchemes(formattedSchemes);
            console.log("Formatted Schemes:", formattedSchemes);
          } else {
            console.log("Error: Response data is not in the expected format");
          }
        })
        .catch((error) => {
          console.log("API Call Error:", error);
        });
    } else {
      console.log("AuthToken is empty");
    }
  };

  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          setPatientList(res.data?.data);
        });
      getAllInsuranceScheme();
    }
  }, [authToken]);

  const history = useHistory();
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  const Token = () => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const handlePhotoPicked = (dataUrl) => {
    setProfilePhoto(dataUrl);
    setPhotoChanged(true);
  };

  const handlePhotoDiscard = (event) => {
    event.stopPropagation();
    setProfilePhoto(null);
    setPhotoChanged(true);
  };

  const handleDevicePhotoChange = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    if (file.size < 20 * 1024) {
      toast.error("File size must be at least 20KB.");
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      toast.error("File size must not exceed 10MB.");
      return;
    }
    handlePhotoPicked(await convertBase64(file));
  };

  // Fills only the fields present in the OCR'd document_json; leaves the rest untouched.
  const applyDocumentAutofill = (data) => {
    if (!data || typeof data !== "object") return;

    const name =
      data.name ||
      data.patientName ||
      `${data.firstname || ""} ${data.lastname || ""}`.trim();
    if (name) setValue9("name", name);
    if (data.firstname) setValue9("firstname", data.firstname);
    if (data.lastname) setValue9("lastname", data.lastname);

    if (data.gender) {
      const g = String(data.gender).toLowerCase();
      const gender = g.startsWith("m") ? "M" : g.startsWith("f") ? "F" : "O";
      setValue9("gender", gender);
      setSelectedGender(gender);
    }

    const dob = parseDocumentDob(data);
    if (dob) {
      setValue9("dateOfBirth", dob);
      setLastUpdatedField("dob");
    }

    if (data.phoneNumber) setValue9("phoneNumber", data.phoneNumber);
    if (data.email || data.emailId) setValue9("emailId", data.email || data.emailId);
    if (data.locality) setValue9("locality", data.locality);
    if (data.city) setValue9("city", data.city);
    if (data.pincode) setValue9("pincode", data.pincode);
    if (data.country) setValue9("country", data.country);

    if (data.state) {
      const state = String(data.state).toLowerCase();
      setValue9("state", state);
      getStates(data.state);
      setSelectedState(state);
    }
    if (data.district) {
      const district = String(data.district).toLowerCase();
      setValue9("district", district);
      setSelectedDistrict(district);
    }

    if (data.abha_id || data.abhaAddress) {
      setValue9("abhaAddress", data.abha_id || data.abhaAddress);
    }
    if (data.abha_no || data.abhaNumber) {
      setValue9("abhaNumber", data.abha_no || data.abhaNumber);
    }
  };

  useEffect(() => {
    const abdmFlag = sessionStorage.getItem("isAbdmEnabled");
    if (abdmFlag !== undefined && abdmFlag !== null) {
      setIsAbdmEnabled(JSON.parse(abdmFlag));
    }
  }, []);

  console.log("abdm", isAbdmEnabled);

  function fetchPatientDetails() {
    if (healthIdDetails || PatientData) {
      if (Token()) {
        axios
          .get(
            `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
            {
              headers: headers,
            }
          )
          .then((response) => {
            // Check if the response status is 200 and the data is an array
            if (response.status === 200 && Array.isArray(response.data?.data)) {
              const patientList = response.data?.data;

              // Check if the patient list is not empty
              if (patientList.length > 0) {
                setPatientListWithAbhaAndId(patientList); // Store the data in state

                // Determine the search key
                let searchKey =
                  healthIdDetails.preferredAbhaAddress ||
                  healthIdDetails.healthId ||
                  healthIdDetails.abhaAddress;

                // Only use PatientData.abha_id if it is not empty
                if (
                  PatientData &&
                  PatientData.abha_id &&
                  PatientData.abha_id.trim() !== ""
                ) {
                  searchKey = PatientData.abha_id;
                }

                // Proceed with searching only if searchKey is defined and not empty
                if (searchKey && searchKey.trim() !== "") {
                  // Find the patient based on the search key
                  const patient = patientList.find(
                    (p) => p.abha_id === searchKey
                  );
                  console.log(patient, "patient");
                  // Set the patient_id or "NA" based on the search result
                  if (patient) {
                    setValue9("patient_id", patient.patient_id);
                  }
                  //  else {
                  //   setValue9("patient_id", "NA");
                  // }
                }
                //  else {
                //   // If searchKey is not defined or is empty, set "NA"
                //   setValue9("patient_id", "NA");
                // }
              } else {
                // If the array is empty
                setValue9("patient_id", "NA");
              }
            } else {
              // Handle cases where response is not 200 or data is not as expected
              console.log("Unexpected response format or status:", response);
              setValue9("patient_id", "NA");
            }
          })
          .catch((error) => {
            console.log("FETCH FAILED", error);
            setValue9("patient_id", "NA");
          });
      }
    }
  }

  const onSubmitAccountMobile = (data) => {
    const matchedPatient = patients.find(
      (patient) => patient.patient_id === selectedPatId
    );
    if (matchedPatient) {
      setPatientForMobileSearch(matchedPatient);
    } else {
      console.log("No matching patient found for the given ID.");
    }
  };

  const handleContinueWithMobileVerification = () => {
    setIsContinueButtonClicked(true);

    const requestBody = {
      scope: ["abha-login", "mobile-verify"],
      loginHint: "mobile",
      loginId: getValues("health_id"),
      otpSystem: "abdm",
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.status !== 500 && res.status !== "Failed") {
          console.log(res);
          console.log(res.data);
          if (res.data.txnId !== undefined && res.data.txnId !== null) {
            toast.success("ABHA Exists to communication Mobile");
            setContinueWithMobileVerificationVisible(true);
            toast.success(res.data.message);
            setTxnIdDownload(res.data.txnId);
            setDisplayDownloadOTPVerify(true);
            // handleVerifyOtpResend();
            handleOtpResendForMobileVerify();
          } else if (res.data.loginId === "Invalid LoginId") {
            toast.error("Please enter a valid mobile number");
          } else {
            toast.error(res.data.error.message);
            setButtonDisabledVerify(false);
            if (res.data.error.code === "ABDM-1115") {
              setNavigateToAbha(true);
            }
          }
        } else {
          toast.error("Failed, please try again after sometime!!");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  };
  const resendMobileVerifictionOfABHA = () => {
    setContinueWithMobileVerificationVisible(true);
    const requestBody = {
      scope: ["abha-login", "mobile-verify"],
      loginHint: "mobile",
      loginId: getValues("health_id"),
      otpSystem: "abdm",
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.status !== 500 && res.status !== "Failed") {
          console.log(res);
          console.log(res.data);
          if (res.data.txnId !== undefined && res.data.txnId !== null) {
            toast.success("ABHA Exists to communication Mobile");
            toast.success(res.data.message);
            setTxnIdDownload(res.data.txnId);
            setDisplayDownloadOTPVerify(true);
            // handleVerifyOtpResend();
            handleOtpResendForMobileVerify();
          } else if (res.data.loginId === "Invalid LoginId") {
            toast.error("Please enter a valid mobile number");
          } else {
            toast.error(res.data.error.message);
            setButtonDisabledVerify(false);
            if (res.data.error.code === "ABDM-1115") {
              setNavigateToAbha(true);
            }
          }
        } else {
          toast.error("Failed, please try again after sometime!!");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  };

  const handleOtpResendForMobileVerify = () => {
    console.log("currentCount", otpResendCountVerifyForMobile);
    if (otpResendCountVerifyForMobile <= 3) {
      setOtpResendCountVerifyForMobile((prevCount) => prevCount + 1);
      setButtonDisabledContinueForMobile(true);

      if (otpResendCountVerifyForMobile < 2) {
        setTimeout(() => {
          setButtonDisabledContinueForMobile(false);
        }, RESEND_OTP_TIMER);
      }
    } else {
      toast.error(
        "You have reached the maximum number of resend attempts. Please try again later."
      );
    }
  };
  const fetchAuthMethodsForAbha = (abhaAddress) => {
    if (Token()) {
      console.log("alert data2", getValues("health_id"));

      var post_data = { abhaAddress };

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/search_abha_v3/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log("API Response:", res.data);
          if (res.status !== "" && res.status < 300) {
            if (res.data.message) {
              toast.error("Cannot process : " + res.data.message);
              // console.log("Cannot process : " + res.data.message);
              // setValue("health_id", "");
            } else {
              let availableAuthMethods = res.data.authMethods || [];

              // Update authModes based on available auth methods
              if (
                availableAuthMethods.includes("MOBILE_OTP") &&
                availableAuthMethods.includes("AADHAAR_OTP")
              ) {
                setAuthModes(["MOBILE_OTP", "AADHAAR_OTP"]);
              } else if (availableAuthMethods.includes("MOBILE_OTP")) {
                setAuthModes(["MOBILE_OTP"]);
              } else if (availableAuthMethods.includes("AADHAAR_OTP")) {
                setAuthModes(["AADHAAR_OTP"]);
              } else {
                setAuthModes([]);
              }

              console.log("Updated Auth Modes:", authModes);
            }
          } else {
            toast.error("Error : " + (res.data.message || "Unknown error"));
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.message || "API call failed");
        });
    }
  };

  // console.log("test..", selectedFileName)
  const submit = (data, e) => {
    e.preventDefault();
    if (otpResendCount >= 3) {
      toast.error(
        "You have reached the maximum number of resend attempts. Please try again later."
      );
      return;
    }
    const auth_mode = getValues("selected_auth_mode");
    if (
      auth_mode === "MOBILE_OTP" &&
      getValues("health_id") &&
      /^\d{10}$/.test(getValues("health_id"))
    ) {
      let filterCriteria;
      filterCriteria = {
        filter_type: "phone_number",
        filter_details: {
          phone_number: getValues("health_id"),
        },
        multipleResults: true,
      };

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_patient_data/`,
          filterCriteria,
          {
            headers: headers,
          }
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.status === "Success") {
            toast.success("Patient Found Successfully");
            // const filteredPatients = response.data.patient_details.filter(
            //   (patient) =>
            //     patient.name &&
            //     patient.patient_id &&
            //     patient.gender &&
            //     patient.dob &&
            //     patient.abha_id &&
            //     patient.abha_no &&
            //     patient.photo
            // );

            setPatients(response.data.patient_details);
            setContinueWithMobileVerification(true);
            setDisableForMobileVerify(true);
          } else if (response.data.status === "Failed") {
            // toast.error(response.data.message);
            toast.error("No Patient Found With This Mobile No");
            // handleContinueWithMobileVerification()
            console.log("alert data", auth_mode);
            console.log("alert data2", getValues("health_id"));
            const requestBody = {
              scope: ["abha-login", "mobile-verify"],
              loginHint: "mobile",
              loginId: getValues("health_id"),
              otpSystem: "abdm",
            };
            axios
              .post(
                `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
                JSON.stringify(requestBody),
                {
                  headers: headers,
                }
              )
              .then((res) => {
                if (res.status !== 500 && res.status !== "Failed") {
                  console.log(res);
                  console.log(res.data);
                  if (res.data.txnId !== undefined && res.data.txnId !== null) {
                    toast.success("ABHA Exists to communication Mobile");
                    toast.success(res.data.message);
                    setTxnIdDownload(res.data.txnId);
                    setDisplayDownloadOTPVerify(true);
                    handleVerifyOtpResend();
                  } else if (res.data.loginId === "Invalid LoginId") {
                    toast.error("Please enter a valid mobile number");
                  } else {
                    toast.error(res.data.error.message);
                    setButtonDisabledVerify(false);
                    if (res.data.error.code === "ABDM-1115") {
                      setNavigateToAbha(true);
                    }
                  }
                } else {
                  toast.error("Failed, please try again after sometime!!");
                }
              })
              .catch((err) => {
                console.log(err);
                toast.error(err);
              });

            setPatients([]);
            setPatients(null);
          } else {
            toast.error("Error");
          }
        })
        .catch((error) => {
          console.log("FETCH FAILED");

          console.log(error);
        });
    } else if (
      auth_mode === "AADHAAR_OTP" &&
      getValues("health_id") &&
      /^\d{12}$/.test(getValues("health_id"))
    ) {
      console.log("alert data", auth_mode);
      console.log("alert data2", getValues("health_id"));
      const requestBody = {
        scope: ["abha-login", "aadhaar-verify"],
        loginHint: "aadhaar",
        loginId: getValues("health_id"),
        otpSystem: "aadhaar",
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.txnId !== undefined && res.data.txnId !== null) {
              setTxnIdDownload(res.data.txnId);
              setDisplayDownloadOTPVerify(true);
              handleVerifyOtpResend();
              toast.success(res.data.message);
            } else {
              toast.error(
                res.data.loginId + ". Please provide a valid Aadhaar number."
              );
              setButtonDisabledVerify(false);
              if (res.data.loginId === "Invalid LoginId") {
                setNavigateToAbha(true);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    } else if (
      auth_mode === "AADHAAR_OTP" &&
      getValues("health_id") &&
      /^\d{10}$/.test(getValues("health_id"))
    ) {
      console.log("alert data", auth_mode);
      console.log("alert data2", getValues("health_id"));
      toast.error("Please choose MOBILE_OTP for mobile number");
    } else if (
      auth_mode === "MOBILE_OTP" &&
      getValues("health_id") &&
      /^\d{12}$/.test(getValues("health_id"))
    ) {
      console.log("alert data", auth_mode);
      console.log("alert data2", getValues("health_id"));
      toast.error("Please choose AADHAAR_OTP for aadhaar number");
    } else if (
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      console.log("alert data", auth_mode);
      console.log("alert data2", getValues("health_id"));
      console.log("inside mobile abha number");
      let healthId = getValues("health_id");

      // Format the healthId if it is a 14-digit number
      if (/^\d{14}$/.test(healthId)) {
        healthId = `${healthId.slice(0, 2)}-${healthId.slice(
          2,
          6
        )}-${healthId.slice(6, 10)}-${healthId.slice(10, 14)}`;
      }
      const requestBody = {
        scope: ["abha-login", "mobile-verify"],
        loginHint: "abha-number",
        loginId: healthId,
        otpSystem: "abdm",
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.txnId !== undefined && res.data.txnId !== null) {
              setTxnIdDownload(res.data.txnId);
              setDisplayDownloadOTPVerify(true);
              handleVerifyOtpResend();
              toast.success(res.data.message);
            } else if (res.data.error) {
              toast.error(res.data.error.message);
            } else {
              toast.error(
                res.data.loginId + ". Please provide a valid ABHA number."
              );
              setButtonDisabledVerify(false);
              if (res.data.loginId === "Invalid LoginId") {
                setNavigateToAbha(true);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    } else if (
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      console.log("alert data", auth_mode);
      console.log("alert data2", getValues("health_id"));
      console.log("inside aadhar abha number");
      let healthId = getValues("health_id");

      // Format the healthId if it is a 14-digit number
      if (/^\d{14}$/.test(healthId)) {
        healthId = `${healthId.slice(0, 2)}-${healthId.slice(
          2,
          6
        )}-${healthId.slice(6, 10)}-${healthId.slice(10, 14)}`;
      }
      const requestBody = {
        scope: ["abha-login", "aadhaar-verify"],
        loginHint: "abha-number",
        loginId: healthId,
        otpSystem: "aadhaar",
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.txnId !== undefined && res.data.txnId !== null) {
              setTxnIdDownload(res.data.txnId);
              setDisplayDownloadOTPVerify(true);
              handleVerifyOtpResend();
              toast.success(res.data.message);
            } else if (res.data.error) {
              toast.error(res.data.error.message);
            } else {
              toast.error(
                res.data.loginId + ". Please provide a valid ABHA number."
              );
              setButtonDisabledVerify(false);
              if (res.data.loginId === "Invalid LoginId") {
                setNavigateToAbha(true);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    } else {
      if (Token()) {
        console.log("alert data", auth_mode);
        console.log("alert data2", getValues("health_id"));
        var post_data = {};
        post_data.abhaAddress = getValues("health_id");
        const alphabetRegex = /[a-zA-Z]/;
        console.log(REACT_APP_SUFFIX, REACT_APP_BACKEND_ROUTE_URL);
        if (alphabetRegex.test(post_data.abhaAddress)) {
          if (!post_data.abhaAddress.endsWith(REACT_APP_SUFFIX)) {
            post_data.abhaAddress += REACT_APP_SUFFIX;
          }
        }
        console.log("post data", post_data);
        const selectedAuthMode = getValues("selected_auth_mode");
        post_data.authMode = selectedAuthMode;
        verifyABHAaddressV3(post_data, undefined);
        // axios
        //   .post(
        //     `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/search_abha_v3/`,
        //     JSON.stringify(post_data),
        //     {
        //       headers: headers,
        //     }
        //   )
        //   .then((res) => {
        //     console.log("API Response:", res.data);
        //     var patientData = patientList.filter(
        //       (item) =>
        //         item.abha_id === res.data.abhaAddress ||
        //         item.abha_no === res.data.healthIdNumber
        //     );

        //     if (res.status !== "" && res.status < 300) {
        //       if (res.data.message) {
        //         toast.error("Cannot process : " + res.data.message);
        //         console.log("Cannot process : " + res.data.message);
        //         setValue("health_id", "");
        //       } else {
        //         const selectedAuthMode = getValues("selected_auth_mode");
        //         let availableAuthMethods = res.data.authMethods || [];

        //         // Update authModes based on available auth methods
        //         if (
        //           availableAuthMethods.includes("MOBILE_OTP") &&
        //           availableAuthMethods.includes("AADHAAR_OTP")
        //         ) {
        //           setAuthModes(["MOBILE_OTP", "AADHAAR_OTP"]); // Case 1
        //         } else if (availableAuthMethods.includes("MOBILE_OTP")) {
        //           setAuthModes(["MOBILE_OTP"]); // Case 2
        //         } else if (availableAuthMethods.includes("AADHAAR_OTP")) {
        //           setAuthModes(["AADHAAR_OTP"]); // Case 3
        //         } else {
        //           setAuthModes([]); // Case 4 (No recognized auth method)
        //         }

        //         console.log("Updated Auth Modes:", authModes);

        //         post_data.authMode = selectedAuthMode;
        //         verifyABHAaddressV3(post_data, undefined);
        //       }
        //     } else {
        //       toast.error("Error : " + (res.data.message || "Unknown error"));
        //     }
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //     toast.error(err.message || "API call failed");
        //   });
      }
    }
  };
  console.log("abdm", isAbdmEnabled);
  const getProfile = (token) => {
    if (Token()) {
      var post_data = {};
      post_data.token = token;
      post_data.patient_id = taggingPatientId;

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}health_id_x_token/get_profile/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log(res.data);
          if (res.status !== "" && res.status < 300) {
            if (res.data.code !== undefined && res.data.details !== undefined) {
              if (res.data.details !== null && res.data.details.length > 0) {
                toast.error("Cannot process : " + res.data.message);
              } else {
                if (res.data.patient_id) {
                  console.log("res.data.patient_id", res.data.patient_id);
                  toast.error(
                    `Patient ID already present with this ABHA address ${res.data.patient_id} `
                  );
                }
                //  else if (res.data.patient) {
                //   setMultipleMatchedData(res.data);
                //   toast.error(
                //     "profile does not match! please choose from the cards"
                //   );
                // }
                else if (
                  res.data.patient &&
                  (!res.data.message ||
                    res.data.message !== "Patient updated successfully !!")
                ) {
                  setMultipleMatchedData(res.data);
                  toast.error(
                    "Patient demographics matching with multiple existing patient records.Please choose from the cards."
                  );
                  setTransactionIdForDataVerification(
                    res.data.transaction_id_internal
                  );
                } else if (res.data.message) {
                  toast.success(res.data.message);
                  setHealthIdDetails(res.data);
                } else {
                  setHealthIdDetails(res.data);
                }
                setDisplayHealthIdDetails(true);
              }
            } else {
              if (res.data.patient_id) {
                console.log("res.data.patient_id", res.data.patient_id);
                toast.error(
                  `Patient ID already present with this ABHA address ${res.data.patient_id} `
                );
              }

              // else if (res.data.patient) {
              //   setMultipleMatchedData(res.data);
              //   toast.error(
              //     "profile does not match! please choose from the cards"
              //   );
              // }
              else if (
                res.data.patient &&
                (!res.data.message ||
                  res.data.message !== "Patient updated successfully !!")
              ) {
                setMultipleMatchedData(res.data);
                toast.error(
                  "Patient demographics matching with multiple existing patient records.Please choose from the cards."
                );
                setTransactionIdForDataVerification(
                  res.data.transaction_id_internal
                );
              } else if (res.data.message) {
                toast.success(res.data.message);
              } else {
                setHealthIdDetails(res.data);
              }
              setDisplayHealthIdDetails(true);
            }
            // if (res.data.phrAddress === "") {
            //   setDisplayPatientDetails(true);
            // } else {

            // }
          } else {
            toast.error("Error : " + res.data.message);
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };

  const handleGenerateOtpResend = () => {
    // console.log("currentCount", otpResendCountGenerate);
    if (otpResendCountGenerate <= 2) {
      setOtpResendCountGenerate((prevCount) => prevCount + 1);
      setButtonDisabled(true);

      if (otpResendCountGenerate < 2) {
        setTimeout(() => {
          setButtonDisabled(false);
        }, RESEND_OTP_TIMER);
      }
    } else {
      toast.error(
        "You have reached the maximum number of resend attempts. Please try again later."
      );
    }
  };

  const downloadABHAUsingTokenPdf = () => {
    // if (e !== undefined) {
    //   e.preventDefault();
    // }
    var post_data = {};
    // if (tokenForCard && /^\d{12}$/.test(getValues("health_id"))) {
    if (
      tokenForCard &&
      ((Token() && /^\d{10}$/.test(getValues("health_id"))) ||
        /^\d{12}$/.test(getValues("health_id")) ||
        (getValues("health_id") &&
          (/^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id")) ||
            /^\d{14}$/.test(getValues("health_id")))))
    ) {
      console.log(tokenForCard);
      post_data.token = tokenForCard;
      //ChangeCursor();
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/get_abha_card_v3/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            var blob = b64toBlob(res.data.value, "image/png");
            const url = window.URL.createObjectURL(blob);
            const pdfWindow = window.open("");
            pdfWindow.document.write(
              "<img width='100%' height='100%' src='" + url + "'></img>"
            );
          } else {
            toast.error(
              "ABHA Download Failed, please try again after sometime!!"
            );
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    } else if (tokenForCard) {
      console.log(tokenForCard);
      post_data.token = tokenForCard;
      //ChangeCursor();
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/phr_card_v3/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          // if (res.status !== 500 && res.status !== "Failed") {
          //   console.log(res);
          //   console.log(res.data);
          //   var blob = b64toBlob(res.data.value, "application/pdf");
          //   const url = window.URL.createObjectURL(blob, {
          //     type: "application/pdf",
          //   });
          //   const pdfWindow = window.open("");
          //   pdfWindow.document.write(
          //     "<iframe width='100%' height='100%' src='" + url + "'></iframe>"
          //   );
          // } else {
          //   toast.error(
          //     "ABHA Download Failed, please try again after sometime!!"
          //   );
          // }
          if (res?.data?.message?.includes("non-KYC ABHA address")) {
            toast.error(res.data.message);
          } else if (res.status !== 500) {
            console.log(res);
            console.log(res.data);
            var blob = b64toBlob(res.data.value, "image/png");
            const url = window.URL.createObjectURL(blob);
            const pdfWindow = window.open("");
            pdfWindow.document.write(
              "<img width='100%' height='100%' src='" + url + "'></img>"
            );
          } else {
            toast.error(
              "ABHA Download Failed, please try again after sometime!!"
            );
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };
  const handleDownlodOtpResend = () => {
    // console.log("currentCount", otpResendCount);
    if (otpResendCount <= 3) {
      setOtpResendCount((prevCount) => prevCount + 1);
      setButtonDisabledAbha(true);

      if (otpResendCount < 2) {
        setTimeout(() => {
          setButtonDisabledAbha(false);
        }, RESEND_OTP_TIMER);
      }
    } else {
      toast.error(
        "You have reached the maximum number of resend attempts. Please try again later."
      );
    }
  };

  console.log("otpResendCount", otpResendCount);

  const downloadABHA = (data, e) => {
    if (otpResendCount >= 3) {
      toast.error(
        "You have reached the maximum number of resend attempts. Please try again later."
      );
      return;
    }
    if (e !== undefined) {
      e.preventDefault();
    }

    var post_data = {};
    if (Token()) {
      post_data.authMethod = "AADHAAR_OTP";
      post_data.healthid = getValues6("abha_id");
      var post_data1 = {};
      post_data1.healthId = getValues6("abha_id");

      if (!post_data1.healthId.endsWith(REACT_APP_SUFFIX)) {
        post_data1.healthId += REACT_APP_SUFFIX;
      }

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}health_id/searchHealthIdToLogin/`,
          JSON.stringify(post_data1),
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log(res.data);
          if (
            res.data.healthId &&
            res.data.healthIdNumber &&
            res.data.authMethods
          ) {
            axios
              .post(
                `${REACT_APP_BACKEND_ROUTE_URL}health_id/health_id_auth_init/`,
                JSON.stringify(post_data),
                {
                  headers: headers,
                }
              )
              .then((res) => {
                if (res.status !== 500 && res.status !== "Failed") {
                  console.log(res);
                  console.log(res.data);
                  if (res.data.txnId !== undefined && res.data.txnId !== null) {
                    setTxnIdDownload(res.data.txnId);
                    setDisplayDownloadOTPDirect(true);
                    handleDownlodOtpResend();
                    setIsButtonClicked(true);
                  } else {
                    if (
                      res.data.details !== undefined &&
                      res.data.details !== null &&
                      res.data.details.length > 0
                    ) {
                      toast.error("Error while fetching : " + res.data.message);
                      toast.error(
                        "Error Message : " + res.data.details[0].message
                      );
                    }
                  }
                } else {
                  toast.error("Failed, please try again after sometime!!");
                }
              })
              .catch((err) => {
                console.log(err);
                toast.error(err.message || "An error occurred");
              });
          } else {
            if (res.data.code === "HIS-422" && res.data.details) {
              const detailMessage =
                res.data.details[0]?.message || "Invalid credentials.";
              toast.error("Error: " + res.data.message);
              toast.error("Detail: " + detailMessage);
            } else {
              toast.error("Unexpected response: " + res.data.message);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.message || "An error occurred");
        });
    }
  };

  const handleVerifyOtpResend = () => {
    // console.log("currentCount", otpResendCount);
    if (otpResendCount <= 3) {
      setOtpResendCount((prevCount) => prevCount + 1);
      setButtonDisabledVerify(true);

      if (otpResendCount < 2) {
        setTimeout(() => {
          setButtonDisabledVerify(false);
        }, RESEND_OTP_TIMER);
      }
    } else {
      toast.error(
        "You have reached the maximum number of resend attempts. Please try again later."
      );
    }
  };

  const verifyABHA = (data, e) => {
    console.log(data);
    if (e) e.preventDefault();
    if (e !== undefined) {
      e.preventDefault();
    }
    //ChangeCursor();
    var post_data = {};
    if (Token()) {
      console.log(data);
      post_data.authMethod = data.authMode;
      post_data.healthid = data.healthId;
      // var post_data1 = {};
      // post_data1.healthId = data.healthId;
      // axios
      //   .post(
      //     `${REACT_APP_BACKEND_ROUTE_URL}health_id/searchHealthIdToLogin/`,
      //     JSON.stringify(post_data1),
      //     {
      //       headers: headers,
      //     }
      //   )
      //   .then((res) => {
      // console.log(res.data);
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}health_id/health_id_auth_init/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.txnId !== undefined && res.data.txnId !== null) {
              setTxnIdDownload(res.data.txnId);
              setDisplayDownloadOTPVerify(true);
              handleVerifyOtpResend();
            } else {
              if (
                res.data.details !== undefined &&
                res.data.details !== null &&
                res.data.details.length > 0
              ) {
                toast.error("Error while fetching : " + res.data.message);
                toast.error("Error Message : " + res.data.details[0].message);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
      // })
      // .catch((err) => {
      //   console.log(err);
      //   toast.error(err);
      //   //ChangeCursor();
      // });
    }
  };

  const verifyABHAaddressV3 = (data) => {
    var post_data = {};
    if (Token()) {
      console.log(data);

      if (data.authMode === "MOBILE_OTP") {
        post_data.scope = ["abha-address-login", "mobile-verify"];
        post_data.loginHint = "abha-address";
        post_data.loginId = data.abhaAddress;
        post_data.otpSystem = "abdm";
      } else if (data.authMode === "AADHAAR_OTP") {
        post_data.scope = ["abha-address-login", "aadhaar-verify"];
        post_data.loginHint = "abha-address";
        post_data.loginId = data.abhaAddress;
        post_data.otpSystem = "aadhaar";
      }

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/login_abha_otp_v3/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.txnId !== undefined && res.data.txnId !== null) {
              setTxnIdDownload(res.data.txnId);
              setDisplayDownloadOTPVerify(true);
              handleVerifyOtpResend();
              toast.success(res.data.message);
            } else {
              if (
                res.data.details !== undefined &&
                res.data.details !== null &&
                res.data.details.length > 0
              ) {
                toast.error("Error while fetching : " + res.data.message);
                toast.error("Error Message : " + res.data.details[0].message);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };

  const downloadOTP = (data, e) => {
    e.preventDefault();
    //ChangeCursor();
    var post_data = {};
    if (Token()) {
      post_data.txnId = txnIdDownload;
      post_data.otp = getValues7("abha_id_otp");
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}health_id/health_id_login_confirm_with_aadhaar_otp/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.token !== undefined && res.data.token !== null) {
              var post_data_for_card = {};
              post_data_for_card.token = res.data.token;
              post_data_for_card.patient_id = taggingPatientId;
              setOtpResendCount(0);
              axios
                .post(
                  `${REACT_APP_BACKEND_ROUTE_URL}health_id_x_token/get_profile/`,
                  JSON.stringify(post_data_for_card),
                  {
                    headers: headers,
                  }
                )
                .then((res) => {
                  if (res.status !== 500 && res.status !== "Failed") {
                    console.log(res.data);
                    setPatientDetails(res.data);
                    axios
                      .post(
                        `${REACT_APP_BACKEND_ROUTE_URL}health_id_x_token/get_card_png/`,
                        JSON.stringify(post_data_for_card),
                        {
                          headers: headers,
                        }
                      )
                      .then((res1) => {
                        if (res.status !== 500 && res.status !== "Failed") {
                          console.log(res1);
                          console.log(res1.data);
                          var blob = b64toBlob(
                            res1.data.value,
                            "application/pdf"
                          );
                          const url = window.URL.createObjectURL(blob, {
                            type: "application/pdf",
                          });

                          const pdfWindow = window.open("");
                          pdfWindow.document.write(
                            "<iframe width='100%' height='100%' src='" +
                            url +
                            "'></iframe>"
                          );
                        } else {
                          toast.error(
                            "ABHA Download Failed, please try again after sometime!!"
                          );
                        }
                      });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              if (
                res.data.details !== undefined &&
                res.data.details !== null &&
                res.data.details.length > 0
              ) {
                toast.error("Error while fetching : " + res.data.message);
                toast.error("Error Message : " + res.data.details[0].message);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };

  const fetchDetailsFromOTP = (data, e) => {
    e.preventDefault();
    const auth_mode = getValues("selected_auth_mode");
    //ChangeCursor();
    var post_data = {};
    if (
      Token() &&
      auth_mode === "MOBILE_OTP" &&
      /^\d{10}$/.test(getValues("health_id"))
    ) {
      verifyOtpV3(data);
    } else if (
      auth_mode === "AADHAAR_OTP" &&
      /^\d{12}$/.test(getValues("health_id"))
    ) {
      verifyOtpV3(data);
    } else if (
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      verifyOtpV3(data);
    } else if (
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      verifyOtpV3(data);
    } else {
      verifyOtpV3(data);
      // console.log("non v3");
      // post_data.txnId = txnIdDownload;
      // post_data.otp = getValues8("abha_id_otp");
      // const auth_mode = getValues("selected_auth_mode");
      // var endpoint = "";
      // if (auth_mode === "AADHAAR_OTP") {
      //   endpoint = "health_id_login_confirm_with_aadhaar_otp";
      // } else {
      //   endpoint = "health_id_login_confirm_with_mobile_otp";
      // }
      // axios
      //   .post(
      //     `${REACT_APP_BACKEND_ROUTE_URL}health_id/${endpoint}/`,
      //     JSON.stringify(post_data),
      //     {
      //       headers: headers,
      //     }
      //   )
      //   .then((res) => {
      //     if (res.status !== 500 && res.status !== "Failed") {
      //       console.log(res);
      //       console.log(res.data);
      //       if (res.data.token !== undefined && res.data.token !== null) {
      //         var post_data_for_card = {};
      //         post_data_for_card.token = res.data.token;
      //         post_data_for_card.patient_id = taggingPatientId;
      //         if (displayDownloadOTPVerify === true) {
      //           getProfile(res.data.token);
      //           setTokenForCard(res.data.token);
      //           setOtpResendCount(0);
      //           setDissableAllButtonsVerify(true);
      //         } else {
      //           axios
      //             .post(
      //               `${REACT_APP_BACKEND_ROUTE_URL}health_id_x_token/get_profile/`,
      //               JSON.stringify(post_data_for_card),
      //               {
      //                 headers: headers,
      //               }
      //             )
      //             .then((res) => {
      //               if (res.status !== 500 && res.status !== "Failed") {
      //                 console.log(res.data);
      //                 setPatientDetails(res.data);
      //               }
      //             })
      //             .catch((err) => {
      //               console.log(err);
      //             });
      //         }
      //       } else {
      //         if (
      //           res.data.details !== undefined &&
      //           res.data.details !== null &&
      //           res.data.details.length > 0
      //         ) {
      //           // toast.error("Error while fetching : " + res.data.message);
      //           toast.error("Error Message : " + res.data.details[0].message);
      //         }
      //       }
      //     } else {
      //       toast.error("Failed, please try again after sometime!!");
      //     }
      //     //ChangeCursor();
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     toast.error(err);
      //     //ChangeCursor();
      //   });
    }
  };
  const verifyOtpV3 = (data) => {
    const auth_mode = getValues("selected_auth_mode");
    let endpoint = "";
    let requestBody = {};

    if (
      auth_mode === "MOBILE_OTP" &&
      getValues("health_id") &&
      /^\d{10}$/.test(getValues("health_id"))
    ) {
      endpoint = "abha_v3/profile_verify_otp_v3/";
      requestBody = {
        scope: ["abha-login", "mobile-verify"],
        authData: {
          authMethods: ["otp"],
          otp: {
            txnId: txnIdDownload,
            otpValue: getValues8("abha_id_otp"),
          },
        },
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);

            if (res.data.token !== undefined && res.data.token !== null) {
              toast.success(res.data.message);
              var post_data_for_card = {};
              post_data_for_card.token = res.data.token;
              if (displayDownloadOTPVerify === true) {
                setTokenForCard(res.data.token);
                setTxnIdV3(res.data.txnId);
                setOtpResendCount(0);
                setDissableAllButtonsVerify(true);
                if (res.data.accounts && Array.isArray(res.data.accounts)) {
                  setAccounts(res.data.accounts);
                }
                setNavigateToAbha(false);
              } else {
                // axios
                //   .post(
                //     `${REACT_APP_BACKEND_ROUTE_URL}health_id_x_token/get_profile/`,
                //     JSON.stringify(post_data_for_card),
                //     {
                //       headers: headers,
                //     }
                //   )
                //   .then((res) => {
                //     if (res.status !== 500 && res.status !== "Failed") {
                //       console.log(res.data);
                //       setPatientDetails(res.data);
                //     }
                //   })
                //   .catch((err) => {
                //     console.log(err);
                //   });
                console.log("displayDownloadOTPVerify is not true");
              }
            } else {
              if (res.data.message) {
                toast.error(res.data.message);
              } else {
                toast.error(res.data.otpValue);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    } else if (
      auth_mode === "AADHAAR_OTP" &&
      getValues("health_id") &&
      /^\d{12}$/.test(getValues("health_id"))
    ) {
      endpoint = "abha_v3/profile_verify_otp_v3/";
      requestBody = {
        scope: ["abha-login", "aadhaar-verify"],
        authData: {
          authMethods: ["otp"],
          otp: {
            txnId: txnIdDownload,
            otpValue: getValues8("abha_id_otp"),
          },
        },
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.token !== undefined && res.data.token !== null) {
              var post_data_for_card = {};
              post_data_for_card.token = res.data.token;
              if (displayDownloadOTPVerify === true) {
                toast.success(res.data.message);
                setTokenForCard(res.data.token);
                getProfileV3(res.data.token);
                setOtpResendCount(0);
                setDissableAllButtonsVerify(true);
                setNavigateToAbha(false);
              } else {
                // axios
                //   .post(
                //     `${REACT_APP_BACKEND_ROUTE_URL}health_id_x_token/get_profile/`,
                //     JSON.stringify(post_data_for_card),
                //     {
                //       headers: headers,
                //     }
                //   )
                //   .then((res) => {
                //     if (res.status !== 500 && res.status !== "Failed") {
                //       console.log(res.data);
                //       setPatientDetails(res.data);
                //     }
                //   })
                //   .catch((err) => {
                //     console.log(err);
                //   });
                console.log("displayDownloadOTPVerify is not true");
              }
            } else {
              if (res.data.error) {
                toast.error(res.data.error.message);
                setNavigateToAbha(true);
              } else if (res.data.otpValue) {
                toast.error(res.data.otpValue);
              } else {
                toast.error(res.data.message);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    } else if (
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      endpoint = "abha_v3/profile_verify_otp_v3/";
      requestBody = {
        scope: ["abha-login", "mobile-verify"],
        authData: {
          authMethods: ["otp"],
          otp: {
            txnId: txnIdDownload,
            otpValue: getValues8("abha_id_otp"),
          },
        },
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.token !== undefined && res.data.token !== null) {
              var post_data_for_card = {};
              post_data_for_card.token = res.data.token;
              if (displayDownloadOTPVerify === true) {
                toast.success(res.data.message);
                setTokenForCard(res.data.token);
                getProfileV3(res.data.token);
                setOtpResendCount(0);
                setDissableAllButtonsVerify(true);
                setNavigateToAbha(false);
              } else {
                console.log("displayDownloadOTPVerify is not true");
              }
            } else {
              if (res.data.error) {
                toast.error(res.data.error.message);
                setNavigateToAbha(true);
              } else if (res.data.otpValue) {
                toast.error(res.data.otpValue);
              } else {
                toast.error(res.data.message);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    } else if (
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      endpoint = "abha_v3/profile_verify_otp_v3/";
      requestBody = {
        scope: ["abha-login", "aadhaar-verify"],
        authData: {
          authMethods: ["otp"],
          otp: {
            txnId: txnIdDownload,
            otpValue: getValues8("abha_id_otp"),
          },
        },
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.token !== undefined && res.data.token !== null) {
              var post_data_for_card = {};
              post_data_for_card.token = res.data.token;
              if (displayDownloadOTPVerify === true) {
                toast.success(res.data.message);
                setTokenForCard(res.data.token);
                getProfileV3(res.data.token);
                setOtpResendCount(0);
                setDissableAllButtonsVerify(true);
                setNavigateToAbha(false);
              } else {
                console.log("displayDownloadOTPVerify is not true");
              }
            } else {
              if (res.data.error) {
                toast.error(res.data.error.message);
                setNavigateToAbha(true);
              } else if (res.data.otpValue) {
                toast.error(res.data.otpValue);
              } else {
                toast.error(res.data.message);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    } else {
      if (auth_mode === "AADHAAR_OTP") {
        endpoint = "abha_v3/verify_abha_otp_v3/";
        requestBody = {
          scope: ["abha-address-login", "aadhaar-verify"],
          authData: {
            authMethods: ["otp"],
            otp: {
              txnId: txnIdDownload,
              otpValue: getValues8("abha_id_otp"),
            },
          },
        };
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
            JSON.stringify(requestBody),
            {
              headers: headers,
            }
          )
          .then((res) => {
            if (res.status !== 500 && res.status !== "Failed") {
              console.log(res);
              console.log(res.data);
              if (
                res.data.message === "OTP verified successfully" &&
                res.data.tokens.token !== null
              ) {
                var post_data_for_card = {};
                post_data_for_card.token = res.data.tokens.token;
                if (displayDownloadOTPVerify === true) {
                  toast.success(res.data.message);

                  // getProfileV3(res.data.tokens.token);
                  getProfileV3AbhaAddress(res.data.tokens.token);
                  setTokenForCard(res.data.tokens.token);

                  setOtpResendCount(0);
                  setDissableAllButtonsVerify(true);
                  setNavigateToAbha(false);
                } else {
                  console.log("displayDownloadOTPVerify is not true");
                }
              } else {
                if (res.data.error) {
                  toast.error(res.data.error.message);
                  setNavigateToAbha(true);
                } else if (
                  (Array.isArray(res.data)
                    ? res.data[0]?.message
                    : res.data.message) === "Invalid OTP Request"
                ) {
                  toast.error(
                    Array.isArray(res.data)
                      ? res.data[0]?.message
                      : res.data.message
                  );
                } else if (res.data.otpValue) {
                  toast.error(res.data.otpValue);
                } else {
                  toast.error(res.data.message);
                }
              }
            } else {
              toast.error("Failed, please try again after sometime!!");
            }
            //ChangeCursor();
          })
          .catch((err) => {
            console.log(err);
            toast.error(err);
            //ChangeCursor();
          });
      } else if (auth_mode === "MOBILE_OTP") {
        endpoint = "abha_v3/verify_abha_otp_v3/";
        requestBody = {
          scope: ["abha-address-login", "mobile-verify"],
          authData: {
            authMethods: ["otp"],
            otp: {
              txnId: txnIdDownload,
              otpValue: getValues8("abha_id_otp"),
            },
          },
        };
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
            JSON.stringify(requestBody),
            {
              headers: headers,
            }
          )
          .then((res) => {
            if (res.status !== 500 && res.status !== "Failed") {
              console.log(res);
              console.log(res.data);
              if (
                res.data.message === "OTP verified successfully" &&
                res.data.tokens.token !== null
              ) {
                var post_data_for_card = {};
                post_data_for_card.token = res.data.tokens.token;
                if (displayDownloadOTPVerify === true) {
                  toast.success(res.data.message);
                  setTokenForCard(res.data.tokens.token);
                  getProfileV3AbhaAddress(res.data.tokens.token);
                  // getProfileV3(res.data.tokens.token);
                  setOtpResendCount(0);
                  setDissableAllButtonsVerify(true);
                  setNavigateToAbha(false);
                } else {
                  console.log("displayDownloadOTPVerify is not true");
                }
              } else {
                if (res.data.error) {
                  toast.error(res.data.error.message);
                  setNavigateToAbha(true);
                } else if (
                  (Array.isArray(res.data)
                    ? res.data[0]?.message
                    : res.data.message) === "Invalid OTP Request"
                ) {
                  toast.error(
                    Array.isArray(res.data)
                      ? res.data[0]?.message
                      : res.data.message
                  );
                } else if (res.data.otpValue) {
                  toast.error(res.data.otpValue);
                } else {
                  toast.error(res.data.message);
                }
              }
            } else {
              toast.error("Failed, please try again after sometime!!");
            }
            //ChangeCursor();
          })
          .catch((err) => {
            console.log(err);
            toast.error(err);
            //ChangeCursor();
          });
      }
    }
  };
  const getProfileV3 = (token) => {
    const requestBody = {
      token: token,
      patient_id: taggingPatientId,
    };

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/get_profile_v3/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.status !== 500 && response.status !== "Failed") {
          console.log("Profile Data:", response.data);
          if (response.data.patient_id) {
            console.log("response.data.patient_id", response.data.patient_id);
            toast.error(
              `Patient ID already present with this ABHA address ${response.data.patient_id} `
            );
          }
          //  else if (response.data.patient) {
          //   setMultipleMatchedData(response.data);
          //   toast.error("profile does not match! please choose from the cards");
          // }
          else if (
            response.data.patient &&
            (!response.data.message ||
              response.data.message !== "Patient updated successfully !!")
          ) {
            setMultipleMatchedData(response.data);
            toast.error(
              "Patient demographics matching with multiple existing patient records.Please choose from the cards."
            );
            setTransactionIdForDataVerification(
              response.data.transaction_id_internal
            );
            console.log(
              "transaction_id_internal inside",
              response.data.transaction_id_internal
            );
          } else if (response.data.message) {
            toast.success(response.data.message);
            setHealthIdDetails(response.data);
          } else {
            setHealthIdDetails(response.data);
          }
        } else {
          toast.error("Failed to fetch profile, please try again later!!");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  };

  const getProfileV3AbhaAddress = (token) => {
    const requestBody = {
      token: token,
      patient_id: taggingPatientId,
    };

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/abha_profile_v3/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.status !== 500 && response.status !== "Failed") {
          console.log("Profile Data:", response.data);
          if (response.data.patient_id) {
            console.log("response.data.patient_id", response.data.patient_id);
            toast.error(
              `Patient ID already present with this ABHA address ${response.data.patient_id} `
            );
          }
          //  else if (response.data.patient) {
          //   setMultipleMatchedData(response.data);
          //   toast.error("profile does not match! please choose from the cards");
          // }
          else if (
            response.data.patient &&
            (!response.data.message ||
              response.data.message !== "Patient updated successfully !!")
          ) {
            setMultipleMatchedData(response.data);
            toast.error(
              "Patient demographics matching with multiple existing patient records.Please choose from the cards."
            );
            setTransactionIdForDataVerification(
              response.data.transaction_id_internal
            );
            console.log(
              "transaction_id_internal inside",
              response.data.transaction_id_internal
            );
          } else if (response.data.message) {
            toast.success(response.data.message);
            setHealthIdDetails(response.data);
          } else {
            setHealthIdDetails(response.data);
          }
        } else {
          toast.error("Failed to fetch profile, please try again later!!");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  };

  const onSubmitAccount = (data) => {
    console.log("Selected Account:", selectedABHANumber);
    console.log("txnIdV3:", txnIdV3);
    const requestBody = {
      ABHANumber: selectedABHANumber,
      txnId: txnIdV3,
      token: tokenForCard,
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/verify_user_v3/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.status !== 500 && response.status !== "Failed") {
          setTokenForCardV3(response.data.token);
          getProfileV3(response.data.token);
          setIsCardSelectionFrozen(true);
        } else {
          toast.error("Failed to fetch profile, please try again later!!");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  };

  const handleCardSelect = (abhaNumber) => {
    setSelectedABHANumber(abhaNumber);
  };
  const downloadABHAUsingTokenPdfV3 = () => {
    console.log("inside v3card download");
    const post_data_for_card = {
      token: tokenForCardV3,
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/get_abha_card_v3/`,
        JSON.stringify(post_data_for_card),
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.status !== 500 && res.status !== "Failed") {
          console.log(res);
          console.log(res.data);
          var blob = b64toBlob(res.data.value, "image/png");
          const url = window.URL.createObjectURL(blob);
          const pdfWindow = window.open("");
          pdfWindow.document.write(
            "<img width='100%' height='100%' src='" + url + "'></img>"
          );
        } else {
          toast.error(
            "ABHA Download Failed, please try again after sometime!!"
          );
        }
        //ChangeCursor();
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
        //ChangeCursor();
      });
  };

  var b64toBlob = function (b64Data, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  // Normalizes various base64 inputs (raw base64, data URLs with incorrect or generic MIME like octet-stream)
  // into a browser-friendly data URL. Defaults to image/jpeg if type cannot be inferred.
  const normalizeBase64Image = (value) => {
    if (!value) return "";
    const trimmed = String(value).trim();

    // If already a data URL with an image/* mime, keep as-is
    if (/^data:image\/(png|jpeg|jpg|webp|gif);base64,/i.test(trimmed)) {
      return trimmed;
    }

    // If data URL but uses application/octet-stream or other generic type, coerce to image/jpeg
    if (/^data:.*;base64,/i.test(trimmed)) {
      return trimmed.replace(/^data:[^;]+;base64,/i, "data:image/jpeg;base64,");
    }

    // If it's raw base64 (no data URL prefix), prepend image/jpeg
    // Allow a simple base64 check (characters A-Z a-z 0-9 + / and = padding)
    if (/^[A-Za-z0-9+/=\r\n]+$/.test(trimmed)) {
      return `data:image/jpeg;base64,${trimmed.replace(/\s+/g, "")}`;
    }

    // Fallback to original value
    return trimmed;
  };

  const phoneChange = watch3("other_number");
  const verifyAbha = watch("health_id");
  const selectedAuthMode = watch("selected_auth_mode");
  const generateAbhafield = watch1("Aadhaar_number");
  const downloadABHAfield = watch6("abha_id");

  useEffect(() => {
    if (
      generateAbhafield !== undefined &&
      generateAbhafield.length > 0 &&
      (displayOtpVerify === true || displayPatientDetails === true)
    ) {
      setDisplayHealthIdDetails(false);
      setDisplayDownloadOTPVerify(false);
      setHealthIdDetails(false);

      setDisplayDownloadOTPDirect(false);
      setPatientDetails([]);
      setDisplayPreview(false);
    }
  }, [generateAbhafield]);

  useEffect(() => {
    if (
      downloadABHAfield !== undefined &&
      downloadABHAfield.length > 0 &&
      (displayDownloadOTPDirect === true || displayPreview === true)
    ) {
      setDisplayHealthIdDetails(false);
      setDisplayDownloadOTPVerify(false);
      setHealthIdDetails(false);

      setDisplayOtpVerify(false);
      setDisplayPatientDetails(false);
      setDisplayVerfiyPhoneNum(false);
      setDisplayGeneratehealthId(false);
    }
  }, [downloadABHAfield]);

  useEffect(() => {
    console.log(verifyAbha);
    if (
      verifyAbha !== undefined &&
      verifyAbha.length > 0 &&
      (displayHealthIdDetails === true || displayDownloadOTPVerify === true)
    ) {
      setDisplayHealthIdDetails(false);
      setDisplayDownloadOTPVerify(false);
      setHealthIdDetails(false);

      setDisplayDownloadOTPDirect(false);
      setPatientDetails([]);
      setDisplayPreview(false);

      setDisplayOtpVerify(false);
      setDisplayPatientDetails(false);
      setDisplayVerfiyPhoneNum(false);
      setDisplayGeneratehealthId(false);
    }
  }, [verifyAbha]);

  useEffect(() => {
    console.log(selectedAuthMode);
    if (
      selectedAuthMode !== undefined &&
      selectedAuthMode.length > 0 &&
      (displayHealthIdDetails === true || displayDownloadOTPVerify === true)
    ) {
      setDisplayHealthIdDetails(false);
      console.log("HERE!");
      setDisplayDownloadOTPVerify(false);
      setHealthIdDetails(false);
    }
  }, [selectedAuthMode]);

  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    if (
      phoneChange !== undefined &&
      phoneChange.length > 0 &&
      displayVerfiyPhoneNum === true
    ) {
      setDisplayVerfiyPhoneNum(false);
    }
  }, [phoneChange]);

  const submitNewPatient = async (data, e) => {
    e.preventDefault();

    if (registrationType === "EMERGENCY") {
      return;
    }

    // console.log(data.uploaded_photo);
    // const file = data.uploaded_photo[0];
    // const base64 = await convertBase64(file);

    if (!data.dateOfBirth && (age !== "" || ageMonths !== "")) {
      const estimatedDob = estimateDobFromAgeYearsMonths(age, ageMonths);
      if (estimatedDob) {
        data.dateOfBirth = estimatedDob;
      }
    }

    const [yearOfBirth, monthOfBirth, dayOfBirth] = (data.dateOfBirth || "").split("-");
    // const patientName = `${data.firstname || ""} ${data.middlename || ""} ${
    //   data.lastname || ""
    // }`.trim();
    const patientName = `${data.name || ""}`.trim();

    const newData = {
      ...data,
      patientName,
      yearOfBirth,
      monthOfBirth,
      dayOfBirth,
      healthIdNumber: data.abhaNumber,
      healthId: data.abhaAddress,
      registration_type: "OPD",
    };

    const mappedPayer = mapDemoFinancePayer(financialClass, financePayer);
    if (financialClass || mappedPayer) {
      newData.financial_class = {
        financial_class: financialClass || "",
        payer: mappedPayer,
      };
    }

    newData.patient_source = buildDemoPatientSource(
      patientSourceType,
      patientSourceFields
    );

    // photos when it is url or base 64
    if (
      selectedPartiallyMatchedPatient &&
      selectedPartiallyMatchedPatient.profilePhoto
    ) {
      newData.uploaded_photo = selectedPartiallyMatchedPatient.profilePhoto;
    }

    if (PatientData && PatientData.photo) {
      newData.uploaded_photo = PatientData.photo;
    }

    if (data.uploaded_photo && data.uploaded_photo[0]) {
      const file = data.uploaded_photo[0];
      const base64 = await convertBase64(file);
      newData.uploaded_photo = base64;
    }

    // A photo picked (device / phone QR) or discarded via the profile circle wins.
    if (photoChanged) {
      newData.uploaded_photo = profilePhoto || "";
    }
    // axios
    //   .post(
    //     `${REACT_APP_BACKEND_ROUTE_URL}add_patient/`,
    //     JSON.stringify(newData),
    //     {
    //       headers: headers,
    //     }
    //   )
    //   .then((response) => {
    //     if (response.data.message === "Patient created successfully !!") {
    //       toast.success(`${response.data.message} Patient Name: ${patientName}`);
    //     } else {
    //       toast.error(`${response.data.message} Patient Name: ${patientName}`);
    //     }
    //     console.log(response);
    //   })
    //   .catch((error) => {
    //     console.error("Error:", error);
    //   });

    // console.log("newData", newData);
    console.log(
      "transactionIdForDataVerification",
      transactionIdForDataVerification
    );
    const addPatient = () => {
      const updatedData = {
        ...newData,
        transaction_id_internal: transactionIdForDataVerification, // Add transaction_id
      };
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_ROUTE_URL}add_patient/`,
          JSON.stringify(updatedData),
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.data.message.includes("successfully")) {
            const patientId = response.data.patient.patient_id;
            toast.success(
              `${response.data.message} Patient Name: ${displayPatientName(patientName)} , Patient ID: ${patientId}`
            );
            setIsSubmitDisabled(true);
            setTransactionIdForDataVerification("");
            setValue9("patient_id", patientId);
            const newData1 = {
              patient_id: response.data.patient.patient_id,
              hip_id: sessionStorage.getItem("facility_name"),
              insurance_schemes: selectedSchemes,
            };

            axios
              .post(
                `${process.env.REACT_APP_BACKEND_ROUTE_URL}add_patient_static_data/`,
                newData1,
                {
                  headers: headers,
                }
              )
              .then((response) => {
                console.log("Success:", response.data);
              })
              .catch((error) => {
                console.error("Error adding patient static data:", error);
              });
            // } else {
            //   toast.error(
            //     `${response.data.message} Patient Name: ${response.data.patient.name}  Patient ID: ${response.data.patient.patient_id}`
            //   );
            // }
          } else {
            const message =
              response.data.message || "An unknown error occurred.";

            if (message.includes("corrupted")) {
              toast.error(
                "The Facility documents uploaded are corrupted. Please try with a different document."
              );
            } else if (message.includes("virus")) {
              toast.error(
                "The Facility documents uploaded has virus. Please try with a different document."
              );
            } else if (response.data.patient) {
              toast.error(
                `${response.data.message} Patient Name: ${displayPatientName(response.data.patient.name)}  Patient ID: ${response.data.patient.patient_id}`
              );
            } else {
              toast.error(message);
            }
          }
        })
        .catch((error) => {
          const rawMessage =
            error?.response?.data?.message?.message ??
            error?.response?.data?.message ??
            error?.response?.data?.detail ??
            error?.message;
          const extractedValidationMessage =
            typeof rawMessage === "string"
              ? rawMessage.match(
                /['"]name['"]\s*:\s*\[\s*['"]([^'"]+)['"]\s*\]/
              )?.[1]
              : null;
          const message =
            extractedValidationMessage ||
            (typeof rawMessage === "string"
              ? rawMessage
              : "Unable to process request.");
          toast.error(message);
          console.error("Error:", error);
        });
    };

    const editPatient = () => {
      console.log("editPatient");
      const facility_id = sessionStorage.getItem("facility_name");
      if (facility_id) {
        newData.facility_id = facility_id;
      }
      newData.patient_id = PatientData.patient_id;
      newData.abha_no = newData.abhaNumber;
      newData.abha_id = newData.abhaAddress;
      newData.transaction_id_internal = transactionIdForDataVerification;
      if (newData.dateOfBirth) {
        newData.birthdate = formatDate(newData.dateOfBirth);
        delete newData.dateOfBirth;
      }
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_ROUTE_URL}edit_patient/`,
          JSON.stringify(newData),
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.data.message.includes("successfully")) {
            toast.success(
              `${response.data.message} Patient Name: ${displayPatientName(patientName)}`
            );
          } else {
            toast.error(
              `${response.data.message} Patient Name: ${displayPatientName(patientName)}`
            );
          }
          console.log(response);
          console.log("inside_update", selectedSchemes);
          const newData1 = {
            patient_id: PatientData.patient_id,
            hip_id: sessionStorage.getItem("facility_name"),
            insurance_schemes: selectedSchemes,
          };

          axios
            .post(
              `${process.env.REACT_APP_BACKEND_ROUTE_URL}add_patient_static_data/`,
              newData1,
              {
                headers: headers,
              }
            )
            .then((response) => {
              console.log("Success:", response.data);
              if (response.data.status === "Success") {
                reset9();
                setPatientData("");
                resetCompletePage();
                setPatientForMobileSearch("");
                setSelectedState("");
                setSelectedDistrict("");
                setSelectedSchemes([]);
                setSelectedGender("");
                setCities([]);
              } else {
                console.log(response.data.message);
              }
            })
            .catch((error) => {
              console.error("Error adding patient static data:", error);
            });
        })
        .catch((error) => {
          const rawMessage =
            error?.response?.data?.message?.message ??
            error?.response?.data?.message ??
            error?.response?.data?.detail ??
            error?.message;
          const extractedValidationMessage =
            typeof rawMessage === "string"
              ? rawMessage.match(
                /['"]name['"]\s*:\s*\[\s*['"]([^'"]+)['"]\s*\]/
              )?.[1]
              : null;
          const message =
            extractedValidationMessage ||
            (typeof rawMessage === "string"
              ? rawMessage
              : "Unable to process request.");
          toast.error(message);
          console.error("Error:", error);
        });
    };
    const editPatientForAbdmFlows = () => {
      const facility_id = sessionStorage.getItem("facility_name");
      if (facility_id) {
        newData.facility_id = facility_id;
      }
      console.log("inside editPatientForAbdmFlows");
      newData.abha_no = newData.abhaNumber;
      newData.abha_id = newData.abhaAddress;
      newData.transaction_id_internal = transactionIdForDataVerification;
      if (newData.dateOfBirth) {
        newData.birthdate = formatDate(newData.dateOfBirth);
        delete newData.dateOfBirth;
      }

      axios
        .post(
          `${process.env.REACT_APP_BACKEND_ROUTE_URL}edit_patient/`,
          JSON.stringify(newData),
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.data.message.includes("successfully")) {
            toast.success(
              `${response.data.message} Patient Name: ${displayPatientName(patientName)}`
            );
            setTransactionIdForDataVerification("");
          } else {
            toast.error(
              `${response.data.message} Patient Name: ${displayPatientName(patientName)}`
            );
          }
          console.log(response);
          console.log("inside_update", selectedSchemes);
          const newData1 = {
            patient_id: patientIdForSearch,
            hip_id: sessionStorage.getItem("facility_name"),
            insurance_schemes: selectedSchemes,
          };

          axios
            .post(
              `${process.env.REACT_APP_BACKEND_ROUTE_URL}add_patient_static_data/`,
              newData1,
              {
                headers: headers,
              }
            )
            .then((response) => {
              if (response.data.status === "Success") {
                SetPatientIdForSearch("");
                setHealthIdDetails("");
                reset9();
                setSelectedSchemes([]);
                setPatientForMobileSearch("");
                reset11();
                setPatientData("");
                setSelectedState("");
                setSelectedDistrict("");
                setSelectedGender("");
                setSelectedSchemes([]);
                setCities([]);
              } else {
                console.log(response.data.message);
              }
              console.log("Success:", response.data);
            })
            .catch((error) => {
              console.error("Error adding patient static data:", error);
            });
        })
        .catch((error) => {
          const rawMessage =
            error?.response?.data?.message?.message ??
            error?.response?.data?.message ??
            error?.response?.data?.detail ??
            error?.message;
          const extractedValidationMessage =
            typeof rawMessage === "string"
              ? rawMessage.match(
                /['"]name['"]\s*:\s*\[\s*['"]([^'"]+)['"]\s*\]/
              )?.[1]
              : null;
          const message =
            extractedValidationMessage ||
            (typeof rawMessage === "string"
              ? rawMessage
              : "Unable to process request.");
          toast.error(message);
          console.error("Error:", error);
        });
    };

    if (showFind) {
      editPatient();
    } else if (patientIdForSearch) {
      editPatientForAbdmFlows();
    } else {
      addPatient();
    }
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const searchType = watch11("searchType");
  const formatAbhaNumber = (abhaNumber) => {
    return abhaNumber.replace(/(\d{2})(\d{4})(\d{4})(\d{4})/, "$1-$2-$3-$4");
  };

  const onSubmit = (data) => {
    console.log(data);

    let filterCriteria;

    switch (data.searchType) {
      case "abhaId":
        filterCriteria = {
          filter_type: "abha_id",
          filter_details: {
            abha_id: data.searchQuery,
          },
          multipleResults: true,
        };
        break;
      case "abhaNo":
        const formattedAbhaNumber = formatAbhaNumber(data.searchQuery);
        filterCriteria = {
          filter_type: "abha_number",
          filter_details: {
            abha_number: formattedAbhaNumber,
          },
          multipleResults: true,
        };
        break;
      case "PatID":
        const formattedPatId = formatAbhaNumber(data.searchQuery);
        filterCriteria = {
          filter_type: "patient_id",
          filter_details: {
            patient_id: formattedPatId,
          },
          multipleResults: true,
        };
        break;
      case "phoneNo":
        filterCriteria = {
          filter_type: "phone_number",
          filter_details: {
            phone_number: data.searchQuery,
          },
          multipleResults: true,
        };
        break;
      case "demographics":
        filterCriteria = {
          filter_type: "demographics",
          filter_details: {
            name: data.name,
            gender: data.gender,
            dob: data.dob,
          },
          multipleResults: true,
        };
        break;
      default:
        console.log("Invalid search type");
        return;
    }

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_patient_data/`,
        filterCriteria,
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log(response.data);
        if (response.data.status === "Success") {
          toast.success("Patient Found Successfully");
          setMultiplePatientData(response.data.patient_details);
          setTransactionIdForDataVerification(""); //clear the internal transaction id befor manualy updating
          // setPatientData(response.data.patient_details);
        } else if (response.data.status === "Failed") {
          // toast.error(response.data.error);
          toast.error(response.data.message);
        } else {
          toast.error("Error");
        }
      })
      .catch((error) => {
        console.log("FETCH FAILED");

        console.log(error);
      });
  };

  const getValidationPattern = () => {
    switch (searchType) {
      case "abhaId":
        return /^[0-9]{12}$/;
      case "abhaNo":
        return /^[A-Z0-9]{10}$/;
      case "phoneNo":
        return /^[0-9]{10}$/;
      default:
        return /.*/;
    }
  };

  const clearSearch = () => {
    setShowFind(false);
    reset11();
  };
  const handleDone = () => {
    reset9();
    setValue11("searchQuery", "");
    setValue11("name", "");
    setValue11("gender", "");
    setValue11("dob", "");
    setShowFind(false);
    setPatientData("");
    setHealthIdDetails("");
    setSelectedSchemes([]);

    setValue9("abhaAddress", "");
    setValue9("abhaNumber", "");
    setValue9("firstname", "");
    setValue9("middlename", "");
    setValue9("lastname", "");
    setValue9("name", "");
    setValue9("gender", "");
    setValue9("dateOfBirth", "");
    setAge("");
    setAgeMonths("");
    setLastUpdatedField(null);
    setValue9("country", "");
    setValue9("state", "");
    setValue9("district", "");
    setValue9("locality", "");
    setValue9("city", "");
    setValue9("pincode", "");
    setValue9("phoneNumber", "");
    setValue9("alternatePhoneNumber", "");
    setValue9("emailId", "");
    setValue9("height", "");
    setValue9("weight", "");
    setValue9("uploaded_photo", "");
    setCities([]);

    setMultiplePatientData([]);
  };
  // const handleSelectChange = (e) => {
  //   const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
  //   setSelectedSchemes(selectedOptions);
  // };

  const handleSelectChange = (event) => {
    const options = event.target.options;
    const selectedValues = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedValues.push(options[i].value);
      }
    }
    console.log("test_final", selectedValues);
    setSelectedSchemes(selectedValues);
  };

  console.log("Selected State:", selectedState);
  console.log("Selected District:", selectedDistrict);

  useEffect(() => {
    setProfilePhoto(healthIdDetails.profilePhoto);
    // setValue9("name", healthIdDetails.name);
    setValue9("name", healthIdDetails?.fullName || healthIdDetails?.name || "");
    setValue9("firstname", healthIdDetails.firstName);
    setValue9("middlename", healthIdDetails.middleName);
    setValue9("lastname", healthIdDetails.lastName);
    setValue9("gender", healthIdDetails.gender);
    setSelectedGender(healthIdDetails.gender);
    setValue9("locality", healthIdDetails.address);
    setValue9("city", healthIdDetails.city);
    setValue9("pincode", healthIdDetails.pincode || healthIdDetails.pinCode);
    // if (!healthIdDetails.healthId) {
    //   setValue9("abhaAddress", healthIdDetails.preferredAbhaAddress);
    // } else {
    //   setValue9("abhaAddress", healthIdDetails.healthId);
    // }

    // if (!healthIdDetails.healthIdNumber) {
    //   setValue9("abhaNumber", healthIdDetails.ABHANumber);
    // } else {
    //   setValue9("abhaNumber", healthIdDetails.healthIdNumber);
    // }
    setValue9(
      "abhaAddress",
      healthIdDetails.healthId ||
      healthIdDetails.preferredAbhaAddress ||
      healthIdDetails.abhaAddress
    );
    setValue9(
      "abhaNumber",
      healthIdDetails.healthIdNumber ||
      healthIdDetails.ABHANumber ||
      healthIdDetails.abhaNumber
    );

    setProfilePhoto(healthIdDetails.profilePhoto);
    // setValue9("name", healthIdDetails.name);

    // setValue9("abhaNumber", healthIdDetails.healthIdNumber);
    setValue9("phoneNumber", healthIdDetails.mobile);
    setValue9("emailId", healthIdDetails.email);
    setValue9("aadhaarCard", healthIdDetails.aadhaarCard);
    setValue9("district", healthIdDetails.districtName?.toLowerCase());
    setValue9("state", healthIdDetails.stateName?.toLowerCase());
    if (healthIdDetails.stateName) {
      getStates(healthIdDetails.stateName);
    }
    setSelectedState(healthIdDetails.stateName?.toLowerCase());
    // setValue9("abhaAddress", healthIdDetails.healthId);
    // if (healthIdDetails.stateName) {
    //   getStates(healthIdDetails.stateName.toLowerCase());
    // }

    setSelectedDistrict(healthIdDetails.districtName?.toLowerCase());

    const formattedMonth = healthIdDetails.monthOfBirth
      ? healthIdDetails.monthOfBirth.padStart(2, "0")
      : "";
    const formattedDay = healthIdDetails.dayOfBirth
      ? healthIdDetails.dayOfBirth.padStart(2, "0")
      : "";
    const formattedDateOfBirth = `${healthIdDetails.yearOfBirth}-${formattedMonth}-${formattedDay}`;

    setValue9("dateOfBirth", formattedDateOfBirth);
    setLastUpdatedField("dob");
    // if (healthIdDetails.phrAddress != null) {
    //   setPhrAddress(healthIdDetails.phrAddress);
    // } else {
    //   setPhrAddress([]);
    //   setValue9("abhaAddress", healthIdDetails.healthId);
    // }

    console.log("Updated State:", {
      firstname: getValues9("firstname"),
      middlename: getValues9("middlename"),
      lastname: getValues9("lastname"),
      name: getValues9("name"),
      gender: getValues9("gender"),
      locality: getValues9("locality"),
      city: getValues9("city"),
      pincode: getValues9("pincode"),
      abhaAddress: getValues9("abhaAddress"),
      abhaNumber: getValues9("abhaNumber"),
      phoneNumber: getValues9("phoneNumber"),
      emailId: getValues9("emailId"),
      aadhaarCard: getValues9("aadhaarCard"),
      dateOfBirth: getValues9("dateOfBirth"),
      district: getValues9("district"),
      state: getValues9("state"),
      name: getValues9("name"),
    });
  }, [healthIdDetails]);
  console.log("healthIdDetails", healthIdDetails);
  const handleCardSelectSearch = (patId) => {
    setselectedPatId(patId);
    const matchedPatient = patients.find(
      (patient) => patient.patient_id === patId
    );
    if (matchedPatient) {
      setPatientForMobileSearch(matchedPatient);
      setPatientData(matchedPatient);
      SetPatientIdForSearch(patId);
    } else {
      console.log("No matching patient found for the given ID.");
    }
    console.log("id for search patId", patId);
  };
  console.log("patient_data", PatientData);
  console.log("transaction_id", transactionIdForDataVerification);
  useEffect(() => {
    if (PatientData) {
      // Only changing the attribute for first_name to patientDetails.first_name
      if (PatientData.first_name !== null)
        setValue9("firstname", PatientData.first_name);
      if (PatientData.middle_name !== null)
        setValue9("middlename", PatientData.middle_name);
      if (PatientData.last_name !== null)
        setValue9("lastname", PatientData.last_name);
      if (PatientData.name !== null) setValue9("name", PatientData.name);
      setProfilePhoto(PatientData.photo);
      // if (PatientData.gender !== null) {
      //   setValue9("gender", PatientData.gender);
      //   setSelectedGender(PatientData.gender);
      // }
      if (PatientData.gender !== null) {
        let genderShort;
        if (PatientData.gender === "Male") {
          genderShort = "M";
        } else if (PatientData.gender === "Female") {
          genderShort = "F";
        } else if (PatientData.gender === "Others" || PatientData.gender === "Other" || PatientData.gender === "O") {
          genderShort = "O";
        } else {
          genderShort = PatientData.gender; // In case of unexpected value
        }
        setValue9("gender", genderShort);
        setSelectedGender(genderShort);
      }
      setValue9("district", PatientData.district?.toLowerCase());
      setValue9("state", PatientData.state?.toLowerCase());
      if (PatientData.state) {
        getStates(PatientData.state);
      }

      setSelectedState(PatientData.state?.toLowerCase());
      setSelectedDistrict(PatientData.district?.toLowerCase());

      if (PatientData.address !== null)
        setValue9("locality", PatientData.address_line);
      if (PatientData.city !== null) setValue9("city", PatientData.city);
      if (PatientData.pincode !== null)
        setValue9("pincode", PatientData.pincode);

      if (PatientData.abha_no !== null) {
        setValue9("abhaNumber", PatientData.abha_no);
      } else {
        setValue9("abhaNumber", "NA");
      }
      if (PatientData.phone_no !== null)
        setValue9("phoneNumber", PatientData.phone_no);
      // Read side is snake_case; the edit payload sends it back as camelCase.
      setValue9("alternatePhoneNumber", PatientData.alternate_phone_no ?? "");
      if (PatientData.email !== null) setValue9("emailId", PatientData.email);
      if (PatientData.dob !== null) {
        setValue9("dateOfBirth", PatientData.dob);
        setLastUpdatedField("dob");
      }
      if (PatientData.abha_id !== null) {
        setValue9("abhaAddress", PatientData.abha_id);
      } else {
        setValue9("abhaAddress", "NA");
      }
      if (PatientData.facility !== null)
        setValue9("facility", PatientData.facility);

      if (PatientData.height !== null) setValue9("height", PatientData.height);
      if (PatientData.weight !== null) setValue9("weight", PatientData.weight);

      if (PatientData.health_insurance !== null) {
        setSelectedSchemes(PatientData.health_insurance);
      }
      if (PatientData.patient_id !== null) {
        setValue9("patient_id", PatientData.patient_id);
      }

      // Demo register always posts registration_type "OPD"; UI is General vs Emergency only.
      const finance = PatientData.financial_class;
      if (finance && typeof finance === "object") {
        setFinancialClass(finance.financial_class || "");
        const payerVal = finance.payer === "self_pay" ? "" : finance.payer || "";
        setFinancePayer(payerVal);
      }

      const source = PatientData.patient_source;
      if (source && typeof source === "object") {
        const srcType = source.source_type || "";
        if (srcType === "WALK_IN" || !srcType) {
          setPatientSourceType("");
          setPatientSourceFields({
            hospitalName: "",
            marketingName: "",
            employeeName: "",
            referralDoctorId: "",
          });
        } else {
          setPatientSourceType(srcType);
          setPatientSourceFields({
            hospitalName: srcType === "HOSPITAL" ? source.source_type_value || "" : "",
            marketingName:
              srcType === "MARKETING_PERSON" ? source.source_type_value || "" : "",
            employeeName:
              srcType === "EMPLOYEE" ? source.source_type_value || "" : "",
            referralDoctorId:
              srcType === "EXTERNAL_DOCTOR" ? source.source_type_value || "" : "",
          });
        }
      }

      console.log("Updated State:", {
        firstname: getValues9("firstname"),
        middlename: getValues9("middlename"),
        lastname: getValues9("lastname"),
        name: getValues9("name"),
        gender: getValues9("gender"),
        locality: getValues9("locality"),
        city: getValues9("city"),
        pincode: getValues9("pincode"),
        abhaNumber: getValues9("abhaNumber"),
        phoneNumber: getValues9("phoneNumber"),
        emailId: getValues9("emailId"),
        dateOfBirth: getValues9("dateOfBirth"),
        abhaAddress: getValues9("abhaAddress"),
        facility: getValues9("facility"),
        name: getValues9("name"),
      });
    }
  }, [PatientData]);

  // useEffect(() => {
  //   console.log("transactionIdForDataVerification",transactionIdForDataVerification)
  // }, [transactionIdForDataVerification]);

  console.log(
    "transactionIdForDataVerification",
    transactionIdForDataVerification
  );

  useEffect(() => {
    if (patientForMobileSearch) {
      if (patientForMobileSearch.first_name !== null)
        setValue9("firstname", patientForMobileSearch.first_name);
      if (patientForMobileSearch.middle_name !== null)
        setValue9("middlename", patientForMobileSearch.middle_name);
      if (patientForMobileSearch.last_name !== null)
        setValue9("lastname", patientForMobileSearch.last_name);
      if (patientForMobileSearch.name !== null)
        setValue9("name", patientForMobileSearch.name);

      if (patientForMobileSearch.gender !== null) {
        let genderShort;
        if (patientForMobileSearch.gender === "Male") {
          genderShort = "M";
        } else if (patientForMobileSearch.gender === "Female") {
          genderShort = "F";
        } else if (patientForMobileSearch.gender === "Others" || patientForMobileSearch.gender === "Other" || patientForMobileSearch.gender === "O") {
          genderShort = "O";
        } else {
          genderShort = patientForMobileSearch.gender; // In case of unexpected value
        }
        setValue9("gender", genderShort);
        setSelectedGender(genderShort);
      }

      setValue9("district", patientForMobileSearch.district?.toLowerCase());
      setValue9("state", patientForMobileSearch.state?.toLowerCase());
      if (patientForMobileSearch.state) {
        getStates(patientForMobileSearch.state);
      }

      setSelectedState(patientForMobileSearch.state?.toLowerCase());
      setSelectedDistrict(patientForMobileSearch.district?.toLowerCase());

      if (patientForMobileSearch.address !== null)
        setValue9("locality", patientForMobileSearch.address_line);
      if (patientForMobileSearch.city !== null)
        setValue9("city", patientForMobileSearch.city);
      if (patientForMobileSearch.pincode !== null)
        setValue9("pincode", patientForMobileSearch.pincode);

      if (patientForMobileSearch.abha_no !== null)
        setValue9("abhaNumber", patientForMobileSearch.abha_no);
      if (patientForMobileSearch.phone_no !== null)
        setValue9("phoneNumber", patientForMobileSearch.phone_no);
      if (patientForMobileSearch.email !== null)
        setValue9("emailId", patientForMobileSearch.email);
      if (patientForMobileSearch.dob !== null) {
        setValue9("dateOfBirth", patientForMobileSearch.dob);
        setLastUpdatedField("dob");
      }
      if (patientForMobileSearch.abha_id !== null)
        setValue9("abhaAddress", patientForMobileSearch.abha_id);
      if (patientForMobileSearch.facility !== null)
        setValue9("facility", patientForMobileSearch.facility);

      if (patientForMobileSearch.height !== null)
        setValue9("height", patientForMobileSearch.height);
      if (patientForMobileSearch.weight !== null)
        setValue9("weight", patientForMobileSearch.weight);

      if (patientForMobileSearch.health_insurance !== null) {
        setSelectedSchemes(patientForMobileSearch.health_insurance);
      }
      if (patientForMobileSearch.patient_id !== null) {
        setValue9("patient_id", patientForMobileSearch.patient_id);
      }

      console.log("Updated Mobile Search State:", {
        firstname: getValues9("firstname"),
        middlename: getValues9("middlename"),
        lastname: getValues9("lastname"),
        gender: getValues9("gender"),
        locality: getValues9("locality"),
        city: getValues9("city"),
        pincode: getValues9("pincode"),
        abhaNumber: getValues9("abhaNumber"),
        phoneNumber: getValues9("phoneNumber"),
        emailId: getValues9("emailId"),
        dateOfBirth: getValues9("dateOfBirth"),
        abhaAddress: getValues9("abhaAddress"),
        facility: getValues9("facility"),
        name: getValues9("name"),
      });
    }
  }, [patientForMobileSearch]);

  useEffect(() => {
    const resetAndSetData = async () => {
      // Step 1: Reset the page
      await resetCompletePageForAddition();

      // Step 2: Check if selectedPartiallyMatchedPatient exists
      if (selectedPartiallyMatchedPatient) {
        // Step 3: Set the data
        setProfilePhoto(selectedPartiallyMatchedPatient.profilePhoto);
        // setValue9("name", selectedPartiallyMatchedPatient.name);
        setValue9(
          "name",
          selectedPartiallyMatchedPatient?.fullName ||
          selectedPartiallyMatchedPatient?.name ||
          ""
        );
        setValue9("firstname", selectedPartiallyMatchedPatient.firstName);
        setValue9("middlename", selectedPartiallyMatchedPatient.middleName);
        setValue9("lastname", selectedPartiallyMatchedPatient.lastName);
        setValue9("gender", selectedPartiallyMatchedPatient.gender);
        setSelectedGender(selectedPartiallyMatchedPatient.gender);
        setValue9("locality", selectedPartiallyMatchedPatient.address);
        setValue9("city", selectedPartiallyMatchedPatient.city);
        setValue9(
          "pincode",
          selectedPartiallyMatchedPatient.pincode ||
          selectedPartiallyMatchedPatient.pinCode
        );
        setValue9("uploaded_photo", selectedPartiallyMatchedPatient.photo);
        // if (!selectedPartiallyMatchedPatient.healthId) {
        //   setValue9(
        //     "abhaAddress",
        //     selectedPartiallyMatchedPatient.preferredAbhaAddress
        //   );
        // } else {
        //   setValue9("abhaAddress", selectedPartiallyMatchedPatient.healthId);
        // }

        // if (!selectedPartiallyMatchedPatient.healthIdNumber) {
        //   setValue9("abhaNumber", selectedPartiallyMatchedPatient.ABHANumber);
        // } else {
        //   setValue9(
        //     "abhaNumber",
        //     selectedPartiallyMatchedPatient.healthIdNumber
        //   );
        // }

        setValue9(
          "abhaAddress",
          selectedPartiallyMatchedPatient.healthId ||
          selectedPartiallyMatchedPatient.preferredAbhaAddress ||
          selectedPartiallyMatchedPatient.abhaAddress
        );
        setValue9(
          "abhaNumber",
          selectedPartiallyMatchedPatient.healthIdNumber ||
          selectedPartiallyMatchedPatient.ABHANumber ||
          selectedPartiallyMatchedPatient.abhaNumber
        );
        // setProfilePhoto(selectedPartiallyMatchedPatient.profilePhoto);
        setValue9("phoneNumber", selectedPartiallyMatchedPatient.mobile);
        setValue9("emailId", selectedPartiallyMatchedPatient.email);
        setValue9("aadhaarCard", selectedPartiallyMatchedPatient.aadhaarCard);
        // setValue9("uploaded_photo", selectedPartiallyMatchedPatient.profilePhoto);
        setValue9(
          "district",
          selectedPartiallyMatchedPatient.districtName?.toLowerCase()
        );
        setValue9(
          "state",
          selectedPartiallyMatchedPatient.stateName?.toLowerCase()
        );

        if (selectedPartiallyMatchedPatient.stateName) {
          getStates(selectedPartiallyMatchedPatient.stateName);
        }
        setSelectedState(
          selectedPartiallyMatchedPatient.stateName?.toLowerCase()
        );
        setSelectedDistrict(
          selectedPartiallyMatchedPatient.districtName?.toLowerCase()
        );

        const formattedMonth = selectedPartiallyMatchedPatient.monthOfBirth
          ? selectedPartiallyMatchedPatient.monthOfBirth.padStart(2, "0")
          : "";
        const formattedDay = selectedPartiallyMatchedPatient.dayOfBirth
          ? selectedPartiallyMatchedPatient.dayOfBirth.padStart(2, "0")
          : "";
        const formattedDateOfBirth = `${selectedPartiallyMatchedPatient.yearOfBirth}-${formattedMonth}-${formattedDay}`;

        setValue9("dateOfBirth", formattedDateOfBirth);
        setLastUpdatedField("dob");

        console.log("Updated State:", {
          firstname: getValues9("firstname"),
          middlename: getValues9("middlename"),
          lastname: getValues9("lastname"),
          name: getValues9("name"),
          gender: getValues9("gender"),
          locality: getValues9("locality"),
          city: getValues9("city"),
          pincode: getValues9("pincode"),
          abhaAddress: getValues9("abhaAddress"),
          abhaNumber: getValues9("abhaNumber"),
          phoneNumber: getValues9("phoneNumber"),
          emailId: getValues9("emailId"),
          aadhaarCard: getValues9("aadhaarCard"),
          dateOfBirth: getValues9("dateOfBirth"),
          district: getValues9("district"),
          state: getValues9("state"),
          photo: getValues9("uploaded_photo"),
        });
      }
    };

    resetAndSetData();
  }, [selectedPartiallyMatchedPatient]);

  console.log("patientForMobileSearch", patientForMobileSearch);
  const handleLinkToGenrateAbha = () => {
    handleCloseVerifyModal();
    setShowGenerateModal(true);
  };

  const resetCompletePage = () => {
    setShowFind(false);
    reset11();
    reset9();
    setHealthIdDetails("");
    setPatientData("");
    SetPatientIdForSearch("");
    setCities([]);
    setSelectedSchemes([]);
    setPatientForMobileSearch("");
    setMultiplePatientData([]);
    setTaggingPatientId();
    setMultiplePatientData([]);
    setProfilePhoto(null);
    setPhotoChanged(false);
    setSelectedState("");
    setSelectedDistrict("");
    setSelectedGender("");
    setAge("");
    setAgeMonths("");
    setLastUpdatedField(null);
    setFinancialClass("");
    setFinancePayer("");
    setPatientSourceType("");
    setPatientSourceFields({
      hospitalName: "",
      marketingName: "",
      employeeName: "",
      referralDoctorId: "",
    });
    if (!showRegistrationTypeDropdown) {
      setRegistrationType("GENERAL");
    }
  };
  const resetCompletePageForAddition = () => {
    setShowFind(false);
    reset11();
    reset9();
    setHealthIdDetails("");
    setPatientData("");
    SetPatientIdForSearch("");
    setCities([]);
    setSelectedSchemes([]);
    setPatientForMobileSearch("");
    setMultiplePatientData([]);
    setTaggingPatientId();
    setAge("");
    setAgeMonths("");
    setLastUpdatedField(null);
    setFinancialClass("");
    setFinancePayer("");
    setPatientSourceType("");
    setPatientSourceFields({
      hospitalName: "",
      marketingName: "",
      employeeName: "",
      referralDoctorId: "",
    });
  };

  // const handleViewPatient =(id)=>{
  //   toast.error("Data fetched ")
  //   console.log("id",id)
  // }

  const handleViewPatient = (id) => {
    const patient = multiplePatientData.find(
      (patient) => patient.patient_id === id
    );

    if (patient) {
      toast.success(`Patient data found: ${displayPatientName(patient.name)}`);
      setPatientData(patient);
      console.log("Patient data", patient);
    } else {
      toast.error("Patient not found");
    }
  };

  const isSelectDisabled =
    patients &&
    ((patients.length > 0 && isContinueButtonClicked) ||
      (patients.length === 0 && !isContinueButtonClicked));
  console.log(
    "1st ",
    patients && patients.length > 0 && isContinueButtonClicked
  );
  console.log(
    "2st  ",
    patients && patients.length === 0 && !isContinueButtonClicked
  );
  console.log("final", isSelectDisabled, patients);

  const handleAddNewPatient = (patient) => {
    // Set the selected partially matched patient data
    handleCloseVerifyModal();
    reset9();
    setSelectedPartiallyMatchedPatient(multipleMatchedData);
    console.log("Adding new patient :", multipleMatchedData);
  };

  const handleUpdatePatient = (patientId) => {
    const patient = multipleMatchedData.patient.find(
      (p) => p.patient_id === patientId
    );
    // Logic to update the patient
    reset9();
    console.log("Updating patient with ID:", patient);

    const formattedMonth = multipleMatchedData.monthOfBirth
      ? String(multipleMatchedData.monthOfBirth).padStart(2, "0")
      : "";
    const formattedDay = multipleMatchedData.dayOfBirth
      ? String(multipleMatchedData.dayOfBirth).padStart(2, "0")
      : "";
    const formattedDateOfBirth = multipleMatchedData.yearOfBirth
      ? `${multipleMatchedData.yearOfBirth}-${formattedMonth}-${formattedDay}`
      : null;

    const abhaId =
      multipleMatchedData.abhaAddress ||
      multipleMatchedData.preferredAbhaAddress ||
      multipleMatchedData.healthId ||
      patient.abha_id;

    const abhaNo =
      multipleMatchedData.abhaNumber ||
      multipleMatchedData.ABHANumber ||
      multipleMatchedData.healthIdNumber ||
      patient.abha_no;

    const fullName = multipleMatchedData.name || multipleMatchedData.fullName;

    const mergedData = {
      patient_id: patient.patient_id,
      name: fullName || patient.name,
      first_name: multipleMatchedData.firstName || patient.first_name,
      middle_name: multipleMatchedData.middleName || patient.middle_name,
      last_name: multipleMatchedData.lastName || patient.last_name,
      abha_id: abhaId,
      abha_no: abhaNo,
      gender: multipleMatchedData.gender || patient.gender,
      email: multipleMatchedData.email || patient.email,
      pincode:
        multipleMatchedData.pincode ||
        multipleMatchedData.pinCode ||
        patient.pincode,
      city: multipleMatchedData.townName || patient.city,
      state: multipleMatchedData.stateName || patient.state,
      district: multipleMatchedData.districtName || patient.district,
      address_line: multipleMatchedData.address || patient.address_line,
      age: multipleMatchedData.age || patient.age,
      dob: formattedDateOfBirth,
      phone_no: multipleMatchedData.mobile || patient.phone_no,
      photo: multipleMatchedData.profilePhoto || patient.photo,
      height: multipleMatchedData.height || patient.height,
      weight: multipleMatchedData.weight || patient.weight,
      health_insurance: patient.health_insurance,
      facility: patient.facility,
    };

    console.log("mergedData", mergedData);
    setPatientData(mergedData);
    handleCloseVerifyModal();
  };

  const handleCancelUpdate = (patientId) => {
    // Logic to cancel the update
    console.log("Cancelling update for patient with ID:", patientId);
    handleCloseVerifyModal();
  };

  const handleCardSelectUpdate = (patientId) => {
    setActivePatientId(patientId);
    console.log("Active patient selected:", patientId);
  };

  console.log("activePatientId", activePatientId);
  return (
    <div className="registerPatient">
      {/* <Container>
        <Row>{renderCardsBasedOnRole()}</Row>
      </Container> */}

      <div className="col-sm-12 col-md-12 col-lg-10" style={{ margin: "auto" }}>
        <DevTool control={control} />
        {/* <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={
              profilePhoto
                ? `data:image/jpeg;base64,${profilePhoto}`
                : "/img/patient_Appointment.png"
            }
            alt="Selected File"
            style={{
              width: "200px",
              height: "200px",

              borderRadius: "50%",
            }}
          />
        </div>

        <h1 style={{ textAlign: "center" }}>
          {patientIdForSearch
            ? "Update Patient"
            : showFind
            ? "Search/Edit Patient"
            : "New Patient"}
        </h1> */}

        {/* <div style={{ marginBottom: "20px" }}>
       
          <div
            className="main-title"
            style={{
              margin: 0,
              textAlign: "left", // stays on the left
              marginLeft: "5%",
            }}
          >
            {patientIdForSearch
              ? "Update Patient"
              : showFind
              ? "Search/Edit Patient"
              : "New Patient"}
          </div>

         
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "15px",
              flexWrap: "wrap", // stack on mobile
              gap: "10px",
            }}
          >
         
            <img
              src={
                profilePhoto
                  ? `data:image/jpeg;base64,${profilePhoto}`
                  : "/assets/images/newIcons/patienticon.svg"
              }
              alt="Profile"
              style={{
                width: "clamp(60px, 15vw, 120px)", // responsive size
                height: "auto",
                borderRadius: "50%",
                objectFit: "cover",
                marginLeft: "50px",
              }}
            />

           
            {!showFind && (
              <Link
                href="#"
                onClick={(event) => {
                  if (healthIdDetails) {
                    event.preventDefault();
                  } else {
                    handleFindClick();
                  }
                }}
                className="btn btn__secondary hyperlink search-edit-patient-btn"
                style={{
                  pointerEvents: healthIdDetails ? "none" : "auto",
                  whiteSpace: "nowrap",
                }}
              >
                Search/Edit Patient
              </Link>
            )}
          </div>
        </div> */}

        <div style={{ marginBottom: "20px" }}>
          {/* Row 1: Title */}
          <div
            className="main-title"
            style={{
              margin: 0,
              textAlign: "left",
              marginLeft: "5%",
            }}
          >
            {patientIdForSearch
              ? "Update Patient"
              : showFind
                ? "Search/Edit Patient"
                : isEmergencyRegistration
                  ? "Emergency Registration"
                  : "New Patient"}
          </div>

          {/* Row 2: Grid for Button + Image */}
          <Grid
            container
            alignItems="center"
            style={{ marginTop: "15px", padding: "0 5%" }}
          >
            {/* Button (left, takes 4/12 = 1/3 width) */}
            <Grid item xs={6}>
              {!showFind && !isEmergencyRegistration && (
                <button
                  type="button"
                  onClick={(event) => {
                    if (healthIdDetails) {
                      event.preventDefault();
                    } else {
                      handleFindClick();
                    }
                  }}
                  className="btn btn__secondary hyperlink search-edit-patient-btn"
                  style={{
                    pointerEvents: healthIdDetails ? "none" : "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  Search/Edit Patient
                </button>
              )}
              {!showFind && !isEmergencyRegistration && (
                <button
                  type="button"
                  onClick={() => setUploadDocOpen(true)}
                  className="btn btn__secondary hyperlink search-edit-patient-btn"
                  style={{ whiteSpace: "nowrap", marginLeft: "10px" }}
                >
                  Upload Document
                </button>
              )}
              <ScanDocumentDialog
                open={uploadDocOpen}
                onClose={() => setUploadDocOpen(false)}
                onAutofill={applyDocumentAutofill}
                onTakePhoto={() => {
                  setUploadDocOpen(false);
                  setDocQrOpen(true);
                }}
              />
              <CrossDeviceQrDialog
                open={docQrOpen}
                onClose={() => setDocQrOpen(false)}
                onAutofill={applyDocumentAutofill}
              />
            </Grid>

            {/* Empty spacer (middle, takes 2/12 = pushes image to 2/3 position) */}
            <Grid item xs={2}></Grid>

            {/* Profile Image (placed at 2/3 of width) */}
            <Grid item xs={4} style={{ textAlign: "left" }}>
              <Box
                role="button"
                tabIndex={0}
                aria-label="Choose patient photo"
                aria-haspopup="menu"
                onClick={(e) => setPhotoMenuAnchor(e.currentTarget)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setPhotoMenuAnchor(e.currentTarget);
                  }
                }}
                sx={{
                  position: "relative",
                  display: "inline-block",
                  cursor: "pointer",
                  marginTop: "-40px",
                  borderRadius: "50%",
                  "&:hover .photo-discard, &:focus-within .photo-discard": {
                    opacity: 1,
                  },
                }}
              >
                <Avatar
                  src={profilePhoto ? normalizeBase64Image(profilePhoto) : undefined}
                  alt="Patient photo"
                  sx={{ width: 96, height: 96 }}
                >
                  {!profilePhoto && <PhotoCameraIcon />}
                </Avatar>
                {profilePhoto && (
                  <IconButton
                    className="photo-discard"
                    size="small"
                    aria-label="Discard photo"
                    onClick={handlePhotoDiscard}
                    onKeyDown={(e) => e.stopPropagation()}
                    sx={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      opacity: 0,
                      transition: "opacity 0.15s",
                      bgcolor: "#fff",
                      boxShadow: 1,
                      "&:hover": { bgcolor: "#fff" },
                      "&:focus-visible": { opacity: 1 },
                    }}
                  >
                    <CancelIcon fontSize="small" color="error" />
                  </IconButton>
                )}
              </Box>
              <input
                ref={photoInputRef}
                type="file"
                accept="image/*"
                hidden
                onChange={handleDevicePhotoChange}
                aria-label="Upload patient photo"
              />
              <Menu
                anchorEl={photoMenuAnchor}
                open={Boolean(photoMenuAnchor)}
                onClose={() => setPhotoMenuAnchor(null)}
              >
                <MenuItem
                  onClick={() => {
                    setPhotoMenuAnchor(null);
                    photoInputRef.current?.click();
                  }}
                >
                  Choose from this device
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setPhotoMenuAnchor(null);
                    setPhotoQrOpen(true);
                  }}
                >
                  Upload from phone (QR)
                </MenuItem>
              </Menu>
              <PhotoQrDialog
                open={photoQrOpen}
                onClose={() => setPhotoQrOpen(false)}
                onPhoto={handlePhotoPicked}
              />
            </Grid>
          </Grid>
        </div>

        {/* <div style={{ marginBottom: "20px" }}>
  
  <div
    className="main-title"
    style={{
      margin: 0,
      textAlign: "left", // stays on the left
      marginLeft: "5%",
    }}
  >
    {patientIdForSearch
      ? "Update Patient"
      : showFind
      ? "Search/Edit Patient"
      : "New Patient"}
  </div>

 
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "15px",
      flexWrap: "wrap", // stack on mobile
      gap: "10px",
    }}
  >
  
    {!showFind && (
              <Link
                href="#"
                onClick={(event) => {
                  if (healthIdDetails) {
                    event.preventDefault();
                  } else {
                    handleFindClick();
                  }
                }}
                className="btn btn__secondary hyperlink search-edit-patient-btn"
                style={{
                  pointerEvents: healthIdDetails ? "none" : "auto",
                  whiteSpace: "nowrap",
                }}
              >
                Search/Edit Patient
              </Link>
            )}

    
    <img
      src={
        profilePhoto
          ? `data:image/jpeg;base64,${profilePhoto}`
          : "/assets/images/newIcons/patienticon.svg"
      }
      alt="Profile"
      style={{
        width: "clamp(60px, 15vw, 120px)", // responsive size
        height: "auto",
        borderRadius: "50%",
        objectFit: "cover",
        marginRight: "20px",
      }}
    />
  </div>
</div> */}

        <div className="contact-panel mb-50">
          {showRegistrationTypeDropdown && (
            <div className="row mb-3">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="registrationType">Registration Type</label>
                  <select
                    id="registrationType"
                    className="form-control"
                    value={registrationType}
                    onChange={(e) => {
                      const next = e.target.value;
                      setRegistrationType(next);
                      if (next === "EMERGENCY") {
                        setShowFind(false);
                      }
                    }}
                  >
                    {REGISTRATION_TYPE_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          )}

          {isEmergencyRegistration ? (
            <DemoEmergencyRegisterSection />
          ) : (
            <>
              {showFind && (
                <div>
                  <div className="contact-panel mb-50">
                    <form onSubmit={handleSubmit11(onSubmit)}>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <div className="form-group">
                            <label htmlFor="searchType">Search by:</label>
                            <select
                              className="form-control"
                              name="searchType"
                              {...register11("searchType")}
                            >
                              <option value="abhaId">ABHA Address</option>
                              <option value="abhaNo">ABHA No</option>
                              <option value="phoneNo">Phone No</option>
                              <option value="demographics">Demographics</option>
                              <option value="PatID">PAT ID</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <div className="form-group">
                            <label htmlFor="searchQuery">Enter Search Query:</label>
                            <input
                              disabled={searchType === "demographics"}
                              type="text"
                              className="form-control"
                              placeholder="Query"
                              name="searchQuery"
                              {...register11("searchQuery")}
                            />
                          </div>
                        </div>

                        <div className="col-sm-4 col-md-4 col-lg-4">
                          <div className="form-group">
                            <label htmlFor="name">Name:</label>
                            <input
                              disabled={searchType !== "demographics"}
                              type="text"
                              className="form-control"
                              placeholder="Name"
                              name="name"
                              {...register11("name")}
                            />
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-4 col-lg-4">
                          <div className="form-group">
                            <label htmlFor="gender">Gender:</label>
                            <select
                              className="form-control"
                              disabled={searchType !== "demographics"}
                              name="gender"
                              {...register11("gender")}
                            >
                              <option value="">Gender</option>
                              <option value="M">Male</option>
                              <option value="F">Female</option>
                              <option value="O">Other</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-sm-4 col-md-4 col-lg-4">
                          <div className="form-group">
                            <label htmlFor="dob">DOB:</label>
                            <input
                              disabled={searchType !== "demographics"}
                              type="date"
                              className="form-control"
                              name="dob"
                              {...register11("dob")}
                              max={today}
                            />
                          </div>
                        </div>
                        <div
                          className="col-sm-6 col-md-6 col-lg-6"

                        >
                          <button
                            type="submit"
                            className="btn btn__secondary btn__rounded btn__block mt-3 verify-abha-btn"
                          >
                            Search
                          </button>
                        </div>
                        <div
                          className="col-sm-6 col-md-6 col-lg-6"

                        >
                          <button
                            type="button"
                            className="btn btn__secondary btn__rounded btn__block mt-3 verify-abha-btn"
                            onClick={handleDone}
                          >
                            Done
                          </button>
                        </div>
                      </div>

                      {multiplePatientData && multiplePatientData.length > 0 && (
                        <Box
                          sx={{
                            height: "500px", // Set the height to the desired value
                            overflow: "auto", // Enable scrolling
                            marginTop: "10px",
                            padding: { xs: "5px", lg: "16px" }, // Add some padding if needed
                            border: "1px solid #ddd", // Optional: Add a border around the box
                            borderRadius: "8px", // Optional: Add border-radius for rounded corners
                          }}
                        >
                          <form>
                            <Grid container spacing={1}>
                              {multiplePatientData.map((patient, index) => (
                                <Grid item xs={12} sm={12} md={6} key={index}>
                                  <Card
                                    sx={{
                                      borderRadius: 3,

                                      boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#ffffff",
                                    }}
                                  >
                                    <CardContent>
                                      <Grid
                                        container
                                        alignItems="center"
                                        spacing={2}
                                        sx={{
                                          height: { xs: "auto", md: 400, lg: 200 }, // Auto height for xs and sm, fixed height for md and lg
                                        }}
                                      >
                                        {/* Avatar Section */}
                                        <Grid
                                          item
                                          xs={12}
                                          sm={3}
                                          md={12}
                                          lg={3}
                                          display="flex"
                                          justifyContent="center"
                                        >
                                          <Avatar
                                            alt={displayPatientName(patient.name)}
                                            src={normalizeBase64Image(patient.photo)}
                                            // src={`data:image/jpeg;base64,${patient.photo}`}
                                            sx={{
                                              width: { xs: 60, sm: 80 },
                                              height: { xs: 60, sm: 80 },
                                            }}
                                          />
                                        </Grid>

                                        {/* Patient Information */}
                                        <Grid item xs={12} sm={8} md={9} lg={8}>
                                          <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                              <Typography variant="h6">
                                                {displayPatientName(patient.name)}
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                              <Typography variant="body2">
                                                ABHA Number:{" "}
                                                {patient.abha_no || "-"}
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                              <Typography variant="body2">
                                                Patient ID: {patient.patient_id}
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                              <Typography variant="body2">
                                                ABHA Address:{" "}
                                                {patient.abha_id || "-"}
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                              <Typography variant="body2">
                                                Gender: {patient.gender}
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                              <Typography variant="body2">
                                                DOB: <DisplayDate value={patient.dob} />
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                        </Grid>

                                        {/* Icon Button for View Details */}
                                        <Grid
                                          item
                                          xs={12}
                                          sm={1}
                                          md={3}
                                          lg={1}
                                          display="flex"
                                          justifyContent="center"
                                        >
                                          <IconButton
                                            onClick={() =>
                                              handleViewPatient(patient.patient_id)
                                            }
                                            aria-label="view details"
                                          >
                                            <VisibilityIcon />
                                          </IconButton>
                                        </Grid>
                                      </Grid>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              ))}
                            </Grid>
                          </form>
                        </Box>
                      )}
                    </form>
                  </div>
                </div>
              )}
              <form
                className="contact-panel__form"
                onSubmit={handleSubmit9(submitNewPatient)}
              >
                <div className="row">
                  {/* {!showFind && (
                <>
                  <div className="col-sm-6 col-md-6 col-lg-6"></div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <Link
                      href="#"
                      onClick={handleFindClick}
                      className="hyperlink"
                      style={{ marginLeft: "10px" }}
                    >
                      <SearchIcon style={{ marginRight: "8px" }} />
                      Search/Edit Patient
                    </Link>
                  </div>
                </>
              )} */}

                  {/* {!showFind && (
                <>
                  <div className="col-sm-6 col-md-6 col-lg-6"></div>
                  <div className="col-sm-6 col-md-6 col-lg-6 d-flex justify-content-end">
                    <Link
                      href="#"
                      onClick={(event) => {
                        if (healthIdDetails) {
                          event.preventDefault(); // Prevent the action if healthIdDetails is available
                        } else {
                          handleFindClick();
                        }
                      }}
                      className="btn btn__secondary hyperlink search-edit-patient-btn"
                      style={{
                        pointerEvents: healthIdDetails ? "none" : "auto", // Disable click events when healthIdDetails is available
                      }}
                    >
                      Search/Edit Patient
                    </Link>
                  </div>
                </>
              )} */}

                  {isAbdmEnabled && (
                    <>
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <button
                          type="button"
                          className="btn btn__secondary btn__rounded btn__block mt-3 verify-abha-btn"
                          onClick={handleVerifyButtonClick}
                          disabled={healthIdDetails}
                        >
                          Verify ABHA
                        </button>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-6 mb-4">
                        <button
                          // disabled={healthIdDetails.preferredAbhaAddress}
                          type="button"
                          className="btn btn__secondary btn__rounded btn__block mt-3 generate-abha-btn"
                          onClick={handleGenerateButtonClick}
                          disabled={healthIdDetails}
                        >
                          Generate ABHA
                        </button>
                      </div>
                    </>
                  )}
                  {!isAbdmEnabled && (
                    <>
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <button
                          type="button"
                          className="btn btn__secondary btn__rounded btn__block mt-3 verify-abha-btn"
                          onClick={handleVerifyButtonClick}
                          disabled
                        >
                          Verify ABHA
                        </button>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-6 mb-4">
                        <button
                          type="button"
                          className="btn btn__secondary btn__rounded btn__block mt-3 generate-abha-btn"
                          onClick={handleGenerateButtonClick}
                          disabled
                        >
                          Generate ABHA
                        </button>
                      </div>
                    </>
                  )}

                  {/* <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="abhaAddress">ABHA Address </label>
                  <input

                    type="text"
                    className="form-control"
                    placeholder="Enter ABHA Address"
                    name="abhaAddress"
                    {...register9("abhaAddress")}
                    disabled={!isAbdmEnabled || healthIdDetails}
                  />
                </div>
              </div> */}
                  {/* <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="abhaAddress">
                    ABHA Address 
                  </label>
                  <select
                    className="form-control"
                    name="abhaAddress"
                    {...register9("abhaAddress")}
                    disabled={!isAbdmEnabled }
                  >
                    <option value="" disabled selected>
                      Select ABHA Address
                    </option>
                    {phrAddress.map((address, index) => (
                      <option key={index} value={address}>
                        {address}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}

                  {/* <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="abhaAddress">ABHA Address</label>
                  {phrAddress && phrAddress.length > 0 ? (
                    <select
                      className="form-control"
                      name="abhaAddress"
                      {...register9("abhaAddress")}
                      disabled={!isAbdmEnabled}
                    >
                      {phrAddress.map((address, index) => (
                        <option key={index} value={address}>
                          {address}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter ABHA Address"
                      name="abhaAddress"
                      {...register9("abhaAddress")}
                      disabled={
                        !isAbdmEnabled || healthIdDetails || PatientData
                      }
                    />
                  )}
                </div>
              </div> */}

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="abhaAddress"></label>

                      <input
                        type="text"
                        className="form-control abha-address-input"
                        placeholder="Enter ABHA Address"
                        name="abhaAddress"
                        {...register9("abhaAddress")}
                        disabled={
                          !isAbdmEnabled ||
                          healthIdDetails ||
                          PatientData ||
                          patientForMobileSearch ||
                          selectedPartiallyMatchedPatient
                        }
                      />
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="abhaNumber"></label>
                      <input
                        type="text"
                        className="form-control abha-number-input"
                        placeholder="Enter ABHA Number"
                        name="abhaNumber"
                        // {...register9("abhaNumber")}
                        {...register9("abhaNumber")}
                        disabled={
                          !isAbdmEnabled ||
                          healthIdDetails ||
                          PatientData ||
                          patientForMobileSearch ||
                          selectedPartiallyMatchedPatient
                        }
                      />
                    </div>
                  </div>

                  {/* <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="firstname" className="required-label">
                    First Name
                  </label>

                  <input
                    disabled={healthIdDetails || PatientData}
                    type="text"
                    className="form-control"
                    placeholder="Enter FirstName"
                    name="firstname"
                    {...register9("firstname", {
                      required: "First Name is required.",
                    })}
                  />
                  {errors9.firstname && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors9.firstname.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="middlename">Middle Name</label>

                  <input
                    disabled={healthIdDetails || PatientData}
                    type="text"
                    className="form-control"
                    placeholder="Enter middleName"
                    name="middlename"
                    {...register9("middlename", {})}
                  />
                  {errors9.middlename && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors9.middlename.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="lastname" className="required-label">
                    Last Name
                  </label>
                  <input
                    disabled={healthIdDetails || PatientData}
                    type="text"
                    className="form-control"
                    placeholder="Enter LastName"
                    name="lastname"
                    {...register9("lastname", {
                      // required: "Patient Last Name is required.",
                    })}
                  />
                  {errors9.lastname && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors9.lastname.message}
                    </p>
                  )}
                </div>
              </div> */}
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="name" className="required-label">
                        Name
                      </label>
                      <input
                        // disabled={
                        //   isAbdmEnabled && (
                        //     healthIdDetails ||
                        //     PatientData ||
                        //     patientForMobileSearch ||
                        //     selectedPartiallyMatchedPatient
                        //   )
                        // }
                        disabled={
                          isAbdmEnabled && !!healthIdDetails
                        }
                        type="text"
                        className="form-control"
                        placeholder=""
                        name="name"
                        {...register9("name", {
                          required: "Patient Name is required.",
                        })}
                      />
                      {errors9.lastname && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors9.name.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="gender" className="required-label">
                        Gender
                      </label>
                      <select
                        className="form-control custom-select-style"
                        placeholder=""
                        name="gender"
                        {...register9("gender", {
                          required: "Gender is required.",
                        })}
                        onChange={(e) => setSelectedGender(e.target.value)}
                        value={selectedGender}
                        // disabled={
                        //   isAbdmEnabled && (
                        //     healthIdDetails ||
                        //     PatientData ||
                        //     patientForMobileSearch ||
                        //     selectedPartiallyMatchedPatient
                        //   )
                        // }
                        disabled={
                          isAbdmEnabled && !!healthIdDetails
                        }
                      >
                        {/* <option value=""></option> */}
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                        <option value="O">Others</option>
                      </select>
                      {errors9.gender && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors9.gender.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-3 col-md-3 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="dateOfBirth" className="required-label">
                        Date of Birth
                      </label>
                      <div className="form-group form-group-date">
                        <i className="icon-calendar form-group-icon"></i>
                        <input
                          type="date"
                          className="form-control"
                          id="dateOfBirth"
                          {...register9("dateOfBirth", {
                            required: "Date of Birth is required.",
                            validate: (value) => {
                              if (!value) return true;
                              return (
                                value <= today ||
                                "Date of Birth cannot be in the future."
                              );
                            },
                          })}
                          disabled={
                            isAbdmEnabled && !!healthIdDetails
                          }
                          max={today}
                          onChange={(e) => {
                            register9("dateOfBirth").onChange(e);
                            setLastUpdatedField("dob");
                          }}
                        />
                      </div>
                    </div>
                    {errors9.dateOfBirth && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors9.dateOfBirth.message}
                      </p>
                    )}
                  </div>
                  <div className="col-sm-3 col-md-3 col-lg-3">
                    <div className="form-group">
                      <label className="required-label">Age (Years &amp; Months)</label>
                      <div
                        className="d-flex align-items-center flex-wrap"
                        style={{ gap: "8px" }}
                      >
                        <input
                          type="number"
                          className="form-control"
                          id="ageYears"
                          placeholder="Years"
                          min="0"
                          max="150"
                          style={{ flex: "1 1 72px", minWidth: 0 }}
                          value={age}
                          disabled={isAbdmEnabled}
                          onChange={(e) => {
                            setAge(e.target.value);
                            setLastUpdatedField("age");
                          }}
                        />
                        <span className="text-muted small">y</span>
                        <input
                          type="number"
                          className="form-control"
                          id="ageMonths"
                          placeholder="Months"
                          min="0"
                          max="11"
                          style={{ flex: "1 1 72px", minWidth: 0 }}
                          value={ageMonths}
                          disabled={isAbdmEnabled}
                          onChange={(e) => {
                            setAgeMonths(e.target.value);
                            setLastUpdatedField("age");
                          }}
                        />
                        <span className="text-muted small">m</span>
                      </div>
                      {age === "" &&
                        ageMonths === "" &&
                        errors9.dateOfBirth && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            Age is required.
                          </p>
                        )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="country" className="required-label">
                        Country
                      </label>
                      <select
                        className="form-control"
                        name="country"
                        {...register9("country", {
                          // required: "Country is required.",
                        })}
                        value={country[0]}
                      // onChange={(e) => handleCountry(e.target.value)}
                      >
                        {country.map((country, index) => (
                          <option key={index} value={country}>
                            {country}
                          </option>
                        ))}
                      </select>
                      {errors9.country && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors9.country.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="state">State</label>
                      <select
                        className="form-control"
                        name="state"
                        {...register9("state")}
                        onChange={(e) => {
                          // This handler replaces the one from register9, so the
                          // form value has to be set explicitly or the selection
                          // never reaches the payload.
                          setValue9("state", e.target.value);
                          setSelectedState(e.target.value);
                          getStates(e.target.value);
                        }}
                        value={selectedState}
                      >
                        <option value=""></option>
                        {states.map((state, index) => (
                          <option
                            key={index}
                            value={state.state_name.toLowerCase()}
                          >
                            {state.state_name}
                          </option>
                        ))}
                        {healthIdDetails.stateName &&
                          !states.some(
                            (state) =>
                              state.state_name.toLowerCase() ===
                              healthIdDetails.stateName.toLowerCase()
                          ) && (
                            <option
                              value={healthIdDetails.stateName.toLowerCase()}
                              selected
                            >
                              {healthIdDetails.stateName}
                            </option>
                          )}
                      </select>
                      {errors9.state && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors9.state.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="district">District</label>
                      <select
                        className="form-control"
                        name="district"
                        {...register9("district")}
                        value={selectedDistrict}
                        onChange={(e) => {
                          // Same as State — register9's onChange is overridden here.
                          setValue9("district", e.target.value);
                          setSelectedDistrict(e.target.value);
                        }}
                      >
                        <option value=""></option>
                        {cities.map((city, index) => (
                          <option
                            key={index}
                            value={city.district_name.toLowerCase()}
                          >
                            {city.district_name}
                          </option>
                        ))}
                        {healthIdDetails.districtName &&
                          !cities.some(
                            (city) =>
                              city.district_name.toLowerCase() ===
                              healthIdDetails.districtName.toLowerCase()
                          ) && (
                            <option
                              value={healthIdDetails.districtName.toLowerCase()}
                              selected
                            >
                              {healthIdDetails.districtName.toLowerCase()}
                            </option>
                          )}
                        {/* {PatientData && PatientData.district &&
                      !cities.some(
                        (city) =>
                          city.district_name.toLowerCase() === PatientData.district.toLowerCase()
                      ) && (
                        <option
                          value={PatientData.district.toLowerCase()}
                          selected
                        >
                          {PatientData.district.toLowerCase()}
                        </option>
                      )
                    } */}
                      </select>
                      {errors9.district && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors9.district.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="locality" className="required-label">
                        Address
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        name="locality"
                        {...register9("locality", {
                          required: "Address is required.",
                        })}
                      />
                      {errors9.locality && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors9.locality.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="city">City/Village </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        name="city"
                        {...register9("city", {
                          // required: "City/Village is required.",
                        })}
                      />
                      {errors9.city && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors9.city.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="pincode" className="required-label">
                        Pin Code
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        name="pincode"
                        {...register9("pincode", {
                          required: "Pin Code is required.",
                        })}
                      />
                      {errors9.pincode && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors9.pincode.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="insuranceScheme">Select Health Schemes</label>
                      <select
                        className="form-control health-scheme-select"
                        id="insuranceScheme"
                        value={selectedSchemes}
                        onChange={handleSelectChange}
                      >
                        {insuranceSchemes.map((scheme, index) => (
                          <option key={index} value={scheme}>
                            {scheme}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="phoneNumber" className="required-label">
                        Phone
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="XXXXXXXXXX"
                        name="phoneNumber"
                        {...register9("phoneNumber", {
                          required: "Phone Number is required.",
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "Phone Number must be 10 digits.",
                          },
                        })}
                      />
                      {errors9.phoneNumber && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors9.phoneNumber.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="alternatePhoneNumber">Alternate Phone</label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="XXXXXXXXXX (optional)"
                        name="alternatePhoneNumber"
                        {...register9("alternatePhoneNumber", {
                          validate: (value) =>
                            !value ||
                            /^[0-9]{10}$/.test(value) ||
                            "Alternate Phone must be 10 digits.",
                        })}
                      />
                      {errors9.alternatePhoneNumber && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors9.alternatePhoneNumber.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="emailId">Email Id</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="example@domain.com"
                        name="emailId"
                        // {...register9("emailId", {
                        //   // required: "Email Id is required.",
                        // })}
                        {...register9("emailId", {
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: "Enter a valid email address.",
                          },
                        })}
                      />
                    </div>
                    {errors9.emailId && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors9.emailId.message}
                      </p>
                    )}
                  </div>
                  {/* 
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="height">AadhaarNo</label>
                  
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Aadhaar Card"
                    name="aadhaarCard"
                    {...register9("aadhaarCard", {
                      required: "Aadhaar Card is required.",
                    })}
                  />
                </div>
                {errors9.aadhaarCard && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors9.aadhaarCard.message}
                  </p>
                )}
              </div> */}

                  {/* <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="height">Height</label>
                  <input
                    type="text"
                    className="form-control"
                    id="height"
                    placeholder=""
                    {...register9("height", {
                      // required: "Height is required.",
                    })}
                  />
                </div>
                {errors9.height && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors9.height.message}
                  </p>
                )}
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="weight">Weight</label>
                  <input
                    type="text"
                    className="form-control"
                    id="weight"
                    placeholder=""
                    {...register9("weight", {
                      // required: "Weight is required.",
                    })}
                  />
                </div>
                {errors9.weight && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors9.weight.message}
                  </p>
                )}
              </div> */}

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="patient_id">Patient ID</label>
                      <input
                        type="text"
                        className="form-control"
                        id="patient_id"
                        disabled
                        placeholder="NA"
                        {...register9("patient_id")}
                      />
                    </div>
                    {errors9.patient_id && (
                      <p className="errorMsg" style={{ color: "red" }}>
                        {errors9.patient_id.message}
                      </p>
                    )}
                  </div>

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="financialClass">Financial Class</label>
                      <select
                        id="financialClass"
                        className="form-control"
                        value={financialClass}
                        onChange={(e) => {
                          setFinancialClass(e.target.value);
                          setFinancePayer("");
                        }}
                      >
                        <option value="">Select financial class</option>
                        {DEMO_FINANCIAL_CLASSES.map(([v, l]) => (
                          <option key={v} value={v}>
                            {l}
                          </option>
                        ))}
                        {financialClass &&
                          !DEMO_FINANCIAL_CLASSES.some(([v]) => v === financialClass) && (
                            <option value={financialClass}>{financialClass}</option>
                          )}
                      </select>
                    </div>
                  </div>

                  {financialClass && (
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="financePayer">Payer</label>
                        <select
                          id="financePayer"
                          className="form-control"
                          value={financePayer}
                          onChange={(e) => setFinancePayer(e.target.value)}
                          disabled={loadingFinancePayers}
                        >
                          <option value="">
                            {loadingFinancePayers
                              ? "Loading payers…"
                              : "Select payer"}
                          </option>
                          {financePayers.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                          {financePayer &&
                            !financePayers.some(
                              (o) => o.value === financePayer
                            ) && (
                              <option value={financePayer}>{financePayer}</option>
                            )}
                        </select>
                      </div>
                    </div>
                  )}

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="patientSourceType">Patient Source</label>
                      <select
                        id="patientSourceType"
                        className="form-control"
                        value={patientSourceType}
                        onChange={(e) => {
                          setPatientSourceType(e.target.value);
                          setPatientSourceFields({
                            hospitalName: "",
                            marketingName: "",
                            employeeName: "",
                            referralDoctorId: "",
                          });
                        }}
                      >
                        <option value="">Select source</option>
                        {SOURCE_TYPES.map((s) => (
                          <option key={s.value} value={s.value}>
                            {s.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {patientSourceType === "HOSPITAL" && (
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="hospitalName">Hospital Name</label>
                        <input
                          id="hospitalName"
                          type="text"
                          className="form-control"
                          value={patientSourceFields.hospitalName}
                          onChange={(e) =>
                            setPatientSourceFields((f) => ({
                              ...f,
                              hospitalName: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  )}
                  {patientSourceType === "MARKETING_PERSON" && (
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="marketingName">
                          Marketing Person Name
                        </label>
                        <input
                          id="marketingName"
                          type="text"
                          className="form-control"
                          value={patientSourceFields.marketingName}
                          onChange={(e) =>
                            setPatientSourceFields((f) => ({
                              ...f,
                              marketingName: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  )}
                  {patientSourceType === "EMPLOYEE" && (
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="employeeName">Employee Name</label>
                        <input
                          id="employeeName"
                          type="text"
                          className="form-control"
                          value={patientSourceFields.employeeName}
                          onChange={(e) =>
                            setPatientSourceFields((f) => ({
                              ...f,
                              employeeName: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  )}
                  {patientSourceType === "EXTERNAL_DOCTOR" && (
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="referralDoctorId">Referral Doctor</label>
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                          }}
                        >
                          <select
                            id="referralDoctorId"
                            className="form-control"
                            value={patientSourceFields.referralDoctorId}
                            onChange={(e) =>
                              setPatientSourceFields((f) => ({
                                ...f,
                                referralDoctorId: e.target.value,
                              }))
                            }
                            disabled={loadingReferralDoctors}
                          >
                            <option value="">
                              {loadingReferralDoctors
                                ? "Loading doctors..."
                                : "Select referral doctor"}
                            </option>
                            {referralDoctors.map((d) => (
                              <option key={d.id} value={d.id}>
                                {d.name}
                                {d.phone ? ` · ${d.phone}` : ""}
                              </option>
                            ))}
                          </select>
                          <IconButton
                            aria-label="Add referral doctor"
                            onClick={() => setAddReferralDoctorOpen(true)}
                            type="button"
                          >
                            <AddIcon />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* <div className="col-sm-6 col-md-6 col-lg-6"></div> */}

                  {/* <div
                className="col-sm-3 col-md-3 col-lg-3"
                style={{ marginTop: "15px" }}
              >
                <label
                  htmlFor="photo-upload"
                  id="photo-upload-button"
                  className="btn btn__secondary btn__rounded btn__block mt-6"
                >
                  <input
                    type="file"
                    id="photo-upload"
                    accept="image/*"
                    hidden
                    {...register9("uploaded_photo", {
                      // required: "Photo Upload is required.",
                    })}
                  />
                  Choose Photo
                </label>
                {errors9.uploaded_photo && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors9.uploaded_photo.message}
                  </p>
                )}
              </div> */}
                  <div
                    className="col-sm-3 col-md-3 col-lg-3"
                    style={{
                      display: "flex",
                      marginTop: "25px",
                      paddingRight: "6px",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn__secondary mt-6 choose-photo-btn"
                      aria-haspopup="menu"
                      onClick={(e) => setPhotoMenuAnchor(e.currentTarget)}
                    >
                      Choose Photo
                    </button>
                  </div>

                  {/* Removed the preview column between the two buttons to keep them on the same row */}

                  {/* <div
                className="col-sm-4 col-md-4 col-lg-4"
                style={{ marginLeft: "30%", marginTop: "50px" }}
              >
                <button
                  type="submit"
                  className="btn btn__secondary btn__rounded btn__block mt-6"
                >
                  Submit New Patient
                </button>
              </div> */}
                  <div
                    className="col-sm-2 col-md-2 col-lg-2"
                    style={{
                      marginTop: "25px",
                      display: "flex",
                      justifyContent: "flex-start",
                      paddingLeft: "6px",
                    }}
                  >
                    <button
                      type="submit"
                      className="btn btn__secondary mt-6 submit-details-btn"
                      disabled={
                        isSubmitDisabled && !patientIdForSearch && !showFind
                      }
                    >
                      {/* {showFind ? "Update Patient" : "Submit New Patient"} */}
                      {patientIdForSearch
                        ? "Update Patient"
                        : showFind
                          ? "Update Patient"
                          : "Submit Details"}
                    </button>
                  </div>
                  <div
                    className="col-sm-1 col-md-1 col-lg-1"
                    style={{ marginTop: "25px" }}
                  >
                    <StyledButton>
                      <div
                        onClick={() => {
                          setIsSubmitDisabled(false);
                          resetCompletePage();
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <IconButton>
                          <RefreshIcon />
                        </IconButton>
                        <Typography variant="button" sx={{ ml: 1 }}></Typography>
                      </div>
                    </StyledButton>
                  </div>
                </div>
              </form>
            </>
          )}
        </div>


        <Modal
          show={addReferralDoctorOpen}
          onHide={() => {
            if (addingReferralDoctor) return;
            setAddReferralDoctorOpen(false);
          }}
          centered
          backdrop="static"
          className="register-modal"
          style={{ zIndex: 9999 }}
          backdropClassName="referral-doctor-modal-backdrop"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Referral Doctor to Master</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label htmlFor="newReferralDoctorName">Doctor Name</label>
              <input
                id="newReferralDoctorName"
                type="text"
                className="form-control"
                placeholder="Dr. ..."
                value={newReferralDoctorName}
                onChange={(e) => setNewReferralDoctorName(e.target.value)}
                disabled={addingReferralDoctor}
              />
            </div>
            <div className="form-group mb-0">
              <label htmlFor="newReferralDoctorPhone">Phone</label>
              <input
                id="newReferralDoctorPhone"
                type="text"
                className="form-control"
                placeholder="10-digit phone"
                value={newReferralDoctorPhone}
                onChange={(e) =>
                  setNewReferralDoctorPhone(e.target.value.replace(/\D/g, ""))
                }
                disabled={addingReferralDoctor}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setAddReferralDoctorOpen(false)}
              disabled={addingReferralDoctor}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleAddReferralDoctor}
              disabled={addingReferralDoctor}
            >
              {addingReferralDoctor ? "Adding..." : "Add to Master"}
            </Button>
          </Modal.Footer>
        </Modal>

        <VerifyAbha
          showVerifyModal={showVerifyModal}
          setShowVerifyModal={setShowVerifyModal}
          setHealthIdDetails={updateHealthIdDetails}
          fetchPatientDetails={fetchPatientDetails}
          taggingPatientId={taggingPatientId}
          setMultiplePatientData={setMultiplePatientData}
          setSelectedPartiallyMatchedPatient={setSelectedPartiallyMatchedPatient}
          setPatientData={setPatientData}
          resetForm={reset9}
          setTransactionIdForDataVerification={setTransactionIdForDataVerification}
          onNavigateToGenerateAbha={() => setShowGenerateModal(true)}
          onClose={() => {
            setDisplayPatientDetails(false);
            setDisplayHealthIdDetails(false);
          }}
        />

        {/* Generate ABHA Modal */}
        <GenerateAbha
          showGenerateModal={showGenerateModal}
          setHealthIdDetails={updateHealthIdDetails}
          setShowGenerateModal={setShowGenerateModal}
          onClose={() => {
            setDisplayPatientDetails(false);
            clearSearch();
          }}
          fetchPatientDetails={fetchPatientDetails}
          taggingPatientId={taggingPatientId}
          setMultiplePatientData={setMultiplePatientData}
          setSelectedPartiallyMatchedPatient={
            setSelectedPartiallyMatchedPatient
          }
          setPatientData={setPatientData}
          resetForm={reset9}
          setTransactionIdForDataVerification={
            setTransactionIdForDataVerification
          }
        />
      </div>
      {/* {isAbdmEnabled && (
        <div>
          <h1 style={{ textAlign: "center" }}>Download ABHA Card</h1>
          <div
            className="col-sm-12 col-md-12 col-lg-10"
            style={{ margin: "auto" }}
          >
            <div className="contact-panel mb-50">
              <Link
                href="#"
                onClick={handleDownloadClick}
                className="hyperlink"
              >
                <FileDownloadIcon style={{ marginRight: "8px" }} />
                Click here to download ABHA card
              </Link>
            </div>
          </div>
        </div>
      )} */}

      <Modal
        show={showDownloadAbhaModal}
        onHide={handleCloseDownloadModal}
        className="custom-modal"
        centered
        style={{ zIndex: 9997 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Download ABHA card</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ overflowY: "auto" }}>
          <div>
            <h1 style={{ textAlign: "center" }}>Download ABHA Card</h1>
            <div
              className="col-sm-12 col-md-12 col-lg-7"
              style={{ maxWidth: "100%" }}
            >
              <div className="contact-panel mb-50">
                <form
                  className="contact-panel__form"
                  style={{ paddingTop: "5%" }}
                  onSubmit={handleSubmit6(downloadABHA)}
                >
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <i className="icon-news form-group-icon"></i>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter ABHA Address"
                          name="abha_id"
                          disabled={displayDownloadOTPDirect}
                          {...register6("abha_id", {
                            required: "ABHA Address is required.",
                            minLength: {
                              value: 4,
                              message: "Minimum Length is 4.",
                            },
                            pattern: {
                              value:
                                /^[a-zA-Z0-9](.*[a-zA-Z0-9]){2,}[a-zA-Z0-9]$/,
                              message:
                                "Alphanumeric characters only. Must be between 8 to 18 characters long. Special characters allowed: dot (.) or underscore (_), which cannot be in the beginning or at the end.",
                            },
                          })}
                        />
                        {errors6.abha_id && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors6.abha_id.message}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <button
                        disabled={buttonDisabledAbha}
                        type="submit"
                        id="check_health_id"
                        className="btn btn__secondary btn__block btn__rounded mt-6"
                      >
                        <span>
                          {isButtonClicked
                            ? "Resend OTP"
                            : "Download ABHA Card"}
                        </span>
                        {buttonDisabledAbha &&
                          otpResendCount < 3 &&
                          otpResendCount > 0 && (
                            <ResendOtpTimer duration={RESEND_OTP_TIMER} />
                          )}
                        <i className="icon-arrow-right"></i>
                      </button>
                      <div className="contact-result"></div>
                    </div>
                  </div>
                </form>
                {displayDownloadOTPDirect ? (
                  <form
                    className="contact-panel__form"
                    style={{ paddingTop: "5%" }}
                    onSubmit={handleSubmit7(downloadOTP)}
                  >
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <div className="form-group">
                          <i className="icon-news form-group-icon"></i>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter OTP"
                            name="abha_id_otp"
                            {...register7("abha_id_otp", {
                              required: "OTP for Download is required.",
                              pattern: {
                                value: /^[a-zA-Z0-9]*$/,
                                message:
                                  "OTP should not contain special characters.",
                              },
                            })}
                          />
                          {errors7.abha_id_otp && (
                            <p className="errorMsg" style={{ color: "red" }}>
                              {errors7.abha_id_otp.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <button
                          type="submit"
                          id="check_health_id"
                          className="btn btn__secondary btn__block btn__rounded mt-6"
                        >
                          <span>Verify OTP to download</span>{" "}
                          <i className="icon-arrow-right"></i>
                        </button>
                        <div className="contact-result"></div>
                      </div>
                    </div>
                  </form>
                ) : (
                  []
                )}
                {displayPreview ? (
                  <div>
                    <iframe
                      src={`data:application/pdf;base64,${previewData}`}
                      width="100%"
                      height="600px"
                      title="PDF Preview"
                      style={{ border: "none" }}
                    />
                  </div>
                ) : (
                  []
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDownloadModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default RegisterPatient;
